export const domainTranslations = {
  en: {
    common: {
      search: "Search",
      all: "All",
      currency: "Currency",
      date: "Date",
      download: "Download",
      file: "File",
      from: "From",
      month: "Month",
      notes: "Notes",
      saved: "Saved",
      select: "Select…",
      title: "Title",
      to: "To",
      today: "Today",
      year: "Year",
      name: "Name",
      phone: "Phone",
      address: "Address",
      address2: "Address line 2",
      postalCode: "Postal code",
      city: "City",
      language: "Language",
      active: "Active",
      inactive: "Inactive",
      activate: "Activate",
      deactivate: "Deactivate",
      configured: "Configured",
      notConfigured: "Not configured",
      default: "Default",
      status: "Status",
      exportCsv: "Export CSV",
      selectTime: "Select time…",
      moveUp: "Move up",
      moveDown: "Move down",
      rename: "Rename",
    },
    dashboard: {
      search: "Search all records…",
      noResults: "No results found.",
      openRequests: "Open requests",
      actionableOffers: "Offers needing action",
      activeProjects: "Active projects",
      overdueInvoices: "Overdue invoices",
      outstanding: "Outstanding",
      today: "Today’s work",
      noWorkToday: "No work scheduled today.",
      upcoming: "Upcoming work",
      noUpcoming: "No upcoming work.",
      activity: "Recent activity",
      noActivity: "No activity yet.",
      actionItems: "Needs your attention",
      attentionItem: "Attention item",
      count: "Count",
      priority: "Priority",
      projectStatusTitle: "Project status",
      projectStatusHint: "Projects across their current lifecycle states.",
      financialOverview: "Financial overview",
      financialOverviewHint: "Invoiced, paid and outstanding totals.",
      invoiced: "Invoiced",
      paid: "Paid",
      employeeAvailability: "Employee availability",
      employeeAvailabilityHint: "Today’s scheduled availability and absences.",
      available: "Available",
      absent: "Absent",
      notScheduled: "Not scheduled",
      expenseOverview: "Expense overview",
      expenseOverviewHint: "Submitted employee expenses over six months.",
      catalogSales: "Catalog sales",
      catalogSalesHint: "Top invoiced catalog items over six months.",
      projectStatuses: {
        planned: "Planned",
        active: "Active",
        on_hold: "On hold",
        completed: "Completed",
        cancelled: "Cancelled",
      },
      priorities: {
        low: "Low",
        normal: "Normal",
        high: "High",
      },
    },
    actionItems: {
      missing_prior_month_payroll_statements:
        "Missing prior-month payroll statements",
      missing_prior_year_salary_certificates:
        "Missing prior-year salary certificates",
      incomplete_employee_payroll_readiness:
        "Employees missing payroll details",
      overdue_invoices: "Overdue invoices with an outstanding balance",
      low_stock_catalog_items: "Catalog items at or below their reorder point",
      unscheduled_active_projects: "Active projects without assignments",
      scheduled_offboarding: "Scheduled employee offboarding",
      incomplete_employee_documents: "Employees without documents",
      submitted_requests: "Submitted requests awaiting processing",
      offers_requiring_action: "Offers requiring action",
    },
    planner: {
      title: "Team planner",
      previous: "Previous period",
      previousShort: "Previous",
      today: "Today",
      next: "Next period",
      nextShort: "Next",
      anchorDate: "Planner date",
      view: "Planner view",
      day: "Day",
      week: "Week",
      month: "Month",
      teamMember: "Team member",
      unassigned: "Unassigned",
      noTeam: "No active team members.",
      holidays: "Company holidays",
      holidaysUnavailable: "Holidays could not be loaded.",
      newAssignment: "New assignment",
      editAssignment: "Edit assignment",
      assign: "Assign",
      backlog: "Unscheduled projects",
      backlogHelp: "Drag a project onto a team member and date, or select it.",
      noBacklog: "No unscheduled projects.",
      selectProject: "Select project",
      selectMember: "Select team member",
      startTime: "Start",
      endTime: "End",
      conflicts: "Scheduling conflicts",
      openConflict: "Open project",
      force: "Schedule anyway",
    },
    customers: {
      title: "Customers",
      subtitle: "Manage customer records, addresses and activity.",
      new: "New customer",
      edit: "Edit customer",
      empty: "No customers found.",
      search: "Search customers…",
      allStatuses: "All statuses",
      contact: "Contact",
      address: "Address",
      activity: "Activity",
      duplicateWarning: "Possible duplicate customers found.",
      private: "Private",
      company: "Company",
      number: "Number",
      archived: "Archived",
      created: "Created",
      type: "Customer type",
      companyName: "Company name",
      language: "Document language",
      notes: "Internal notes",
      identity: "Identity and contact",
      contactHint: "A phone number or email address is required.",
      contactRequired: "Enter a phone number or email address.",
      addresses: "Addresses",
      billingAddress: "Billing address",
      workAddress: "Work address",
      sameAddress: "Use the billing address as the work address",
      addressLine1: "Address line 1",
      addressLine2: "Address line 2",
      postalCode: "Postal code",
      city: "City",
      country: "Country",
      location: {
        fill: "Use current location",
        overwrite: "Replace the address fields with your current location?",
        success: "Address filled from your current location.",
        errors: {
          unsupported: "Location is not supported by this browser.",
          insecure:
            "Location requires HTTPS (or localhost during development).",
          denied:
            "Location permission was denied. Allow it in your browser settings.",
          unavailable: "Your current location could not be determined.",
          timeout: "Location lookup timed out. Please try again.",
          no_address: "No Swiss building address was found near this location.",
          network: "The Swiss address service could not be reached.",
        },
      },
      details: "Customer details",
      summary: "Summary",
      noProjects: "No projects.",
      projects: "Projects",
    },
    requests: {
      title: "Requests",
      subtitle: "Capture and review customer work requests.",
      new: "New request",
      empty: "No requests found.",
      details: "Request details",
      description: "Description",
      customerStep: "Customer",
      workStep: "Requested work",
      scheduleStep: "Schedule",
      reviewStep: "Review",
      shortDescription: "Short description",
      selectCustomer: "Select customer",
      category: "Category",
      subcategory: "Subcategory",
      pricing: "Price expectation",
      priority: "Priority",
      requestedDate: "Requested date",
      submitOffice: "Submit to office",
      createOffer: "Create offer",
      assigned: "Assigned employees",
      unassigned: "Unassigned",
      search: "Search requests…",
      allStatuses: "All statuses",
      number: "Number",
      created: "Created",
      captureHint: "Capture the request now; the office can price it later.",
      customerAndWork: "Customer and requested work",
      createCustomer: "Create a new customer",
      general: "General",
      siteAddress: "Work-site address",
      expectations: "Expectations",
      timeMaterial: "Time and materials",
      fixedPrice: "Fixed price",
      fixedAmount: "Fixed amount",
      offerRequired: "Offer required",
      appointmentRequired: "Appointment required",
      asap: "As soon as possible",
      desiredDate: "Desired date",
      date: "Date",
      startTime: "Start time (24-hour HH:mm)",
      endTime: "End time (24-hour HH:mm)",
      scheduling: "Scheduling",
      photos: "Photos",
      addPhotos: "Add photos",
      photoHint: "Add clear photos of the work site and the requested work.",
      takePhoto: "Take photo",
      uploadFiles: "Upload files",
      cameraHint: "Use your device camera or select existing image files.",
      noPhotos: "No photos added.",
      saveDraft: "Save draft",
      ai: {
        title: "AI-assisted capture",
        hint: "Describe or dictate the request in a separate workspace, then review the proposed form values.",
        dictation: "Dictation",
        stopDictation: "Stop recording",
        cancelDictation: "Cancel recording",
        autocomplete: "Auto-fill",
        checkingAvailability: "Checking AI availability…",
        availabilityError:
          "AI availability could not be checked. You can continue manually.",
        disabled: "AI assistance is not configured. You can continue manually.",
        noPermission: "You do not have permission to use AI assistance.",
        unavailable:
          "AI assistance is unavailable for this account. You can continue manually.",
        budgetExhausted:
          "The monthly AI budget has been used. You can continue manually.",
        budgetRemaining: "AI budget remaining: ${{amount}}.",
        recordingTime: "Recording time {{time}}",
        recordingUnsupported:
          "Audio recording is not supported by this browser.",
        recordingUnsupportedManual:
          "Dictation is not supported by this browser; auto-complete and manual entry remain available.",
        requestingMicrophone: "Waiting for microphone permission…",
        recording: "Recording in progress.",
        processing: "Uploading and transcribing the recording…",
        transcribing: "Transcribing…",
        addNotesFirst:
          "Enter at least three characters in a description first.",
        emptyRecording: "No audio was captured.",
        recordingCancelled: "Recording cancelled.",
        microphoneError: "The microphone could not be started: {{message}}",
        dictationError: "The recording could not be processed: {{message}}",
        autocompleteError: "The request could not be generated: {{message}}",
        noChanges: "AI did not suggest any changes.",
        transcriptLabel: "Transcript",
        dictationApplied:
          "The dictation was summarized into the request. Review the fields before saving.",
        autocompleteApplied:
          "Suggestions were added to the request. Review the fields before saving.",
        reviewTitle: "Review proposed changes",
        reviewHint:
          "Some suggestions replace information you already entered. Compare the values before applying them.",
        keepCurrent: "Keep current values",
        applyChanges: "Apply proposed changes",
        currentValue: "Current",
        proposedValue: "Proposed",
        emptyValue: "Empty",
        unknownSelection: "Unavailable selection",
        autocompleteTitle: "Describe the customer request",
        generate: "Generate request",
        promptLabel: "Request details",
        promptHint:
          "Include the requested work, scope, timing, priority and price expectations that were discussed.",
        dictationTitle: "Dictate the customer request",
        dictationHint:
          "Describe all relevant work, scope, timing, priority and pricing details. A professional summary will be generated from the recording.",
        startDictation: "Start recording",
        processingRecording:
          "Transcribing and preparing a professional summary…",
        fields: {
          shortDescription: "Short description",
          description: "Detailed description",
          category: "Category",
          subcategory: "Subcategory",
          pricing: "Pricing expectation",
          fixedAmount: "Fixed amount",
          scheduling: "Scheduling",
          requestedDate: "Desired date",
          startTime: "Preferred start time",
          endTime: "Preferred end time",
          priority: "Priority",
        },
      },
    },
    offers: {
      title: "Offers",
      subtitle: "Prepare, send and track commercial offers.",
      new: "New offer",
      edit: "Edit offer",
      offer: "Offer",
      empty: "No offers found.",
      allStatuses: "All statuses",
      number: "Number",
      validUntil: "Valid until",
      preview: "Preview PDF",
      ready: "Mark ready",
      send: "Send by email",
      accept: "Accept offer",
      decline: "Mark declined",
      hold: "Put on hold",
      resume: "Resume",
      viewProject: "View project",
      status: "Offer status",
      details: "Offer details",
      introduction: "Introduction",
      texts: "Terms and notes",
      terms: "Terms and conditions",
      internalNotes: "Internal notes",
      documentTexts: "Document texts",
      markReady: "Mark as ready",
      revision: "Revision",
    },
    projects: {
      title: "Projects",
      subtitle: "Plan work, people, documents, inventory and costs.",
      project: "Project",
      new: "New project",
      edit: "Edit project",
      empty: "No projects found.",
      search: "Search projects…",
      allStatuses: "All statuses",
      schedule: "Schedule",
      managers: "Managers",
      parent: "Parent project",
      noParent: "No parent",
      selectCustomer: "Select customer",
      plannedStart: "Planned start",
      plannedEnd: "Planned end",
      internalNotes: "Internal notes",
      overview: "Overview",
      documents: "Documents",
      team: "Team",
      financials: "Financials",
      details: "Project details",
      summary: "Summary",
      children: "Subprojects",
      noDescription: "No description.",
      noDocuments: "No linked documents.",
      noMembers: "No project members.",
      budget: "Budget",
      revenueBudget: "Revenue",
      laborBudget: "Labor",
      materialBudget: "Material",
      manualCost: "Recorded costs",
      costs: "Costs",
      noCosts: "No costs recorded.",
      inventory: "Inventory",
      reservations: "Reservations",
      issued: "Issued",
      remaining: "Remaining",
      shortage: "short",
      issue: "Issue stock",
      release: "Release reservation",
      return: "Return stock",
      returnStock: "Return",
      noReservations: "No inventory reservations.",
      transition: {
        active: "Start project",
        on_hold: "Put on hold",
        completed: "Complete project",
        cancelled: "Cancel project",
      },
    },
    invoices: {
      title: "Invoices",
      subtitle: "Issue Swiss invoices and track payments.",
      new: "New invoice",
      edit: "Edit invoice",
      invoice: "Invoice",
      empty: "No invoices found.",
      allStatuses: "All statuses",
      number: "Number",
      date: "Invoice date",
      dueDate: "Due date",
      payment: "Payment",
      details: "Invoice details",
      referenceType: "Reference type",
      paymentTerms: "Payment terms",
      status: "Invoice status",
      issue: "Issue invoice",
      send: "Send by email",
      cancel: "Cancel invoice",
      cancelReason: "Cancellation reason",
      billing: "Billing address",
      sharing: {
        title: "Secure invoice links",
        hint: "Create a private download link that expires after three months. The link is shown only once.",
        create: "Create share link",
        newLink: "New share link",
        copied: "Copied",
        copy: "Copy link",
        inactive: "Inactive link",
        active: "Active link",
        expires: "Expires {{date}} · {{count}} downloads",
        revoke: "Revoke",
      },
    },
    payments: {
      title: "Payments",
      amount: "Amount",
      date: "Payment date",
      method: "Method",
      bank: "Bank transfer",
      cash: "Cash",
      card: "Card",
      other: "Other",
      reference: "Reference",
      record: "Record payment",
      paid: "Paid",
      deleteConfirm: "Delete this payment?",
    },
    commercial: {
      positions: "Positions",
      addPosition: "Add position",
      type: "Type",
      title: "Title",
      description: "Description",
      quantity: "Quantity",
      unit: "Unit",
      unitPrice: "Unit price",
      discountPercent: "Discount %",
      taxRate: "VAT %",
      estimatedSubtotal: "Estimated subtotal",
      subtotal: "Subtotal",
      tax: "VAT",
      total: "Total",
      terms: "Terms and conditions",
      notes: "Internal notes",
      customerNotes: "Customer-visible notes",
      previewCurrent: "Preview current PDF",
      issuedPdf: "Issued PDF",
      validUntil: "Valid until",
      schedule: "Schedule",
      start: "Start",
      end: "End",
      priority: "Priority",
      position: "Position",
      work: "Work",
      product: "Product",
      material: "Material",
      flatRate: "Flat rate",
      text: "Text",
      discount: "Discount %",
      catalogItem: "Catalog item",
      selectCatalogItem: "Select an item…",
      addFromCatalog: "Add from catalog",
      trackedLineLocked:
        "Type and unit are locked while this tracked catalog item is attached.",
      makeManual: "Make manual",
      insufficientAvailability:
        "The requested quantity exceeds currently available stock.",
    },
    catalog: {
      title: "Inventory",
      subtitle: "Manage items, packages, stock and locations.",
      add: "Add item",
      edit: "Edit item",
      empty: "No catalog items.",
      inactive: "Show inactive",
      name: "Name",
      sku: "SKU",
      type: "Type",
      unit: "Unit",
      price: "Unit price",
      tax: "VAT %",
      items: "Items",
      barcode: "Barcode",
      stockTracked: "Track inventory",
      defaultUnitCost: "Default unit cost",
      reorderPoint: "Reorder point",
    },
    inventory: {
      stock: "Stock",
      movements: "Movements",
      locations: "Locations",
      location: "Location",
      allLocations: "All locations",
      allMovements: "All movements",
      receive: "Receive stock",
      receipt: "Receive stock",
      adjust: "Adjust",
      adjustment: "Adjust stock",
      transfer: "Transfer",
      fromLocation: "From location",
      toLocation: "To location",
      direction: "Direction",
      in: "Increase",
      out: "Decrease",
      quantity: "Quantity",
      unitCost: "Unit cost",
      reason: "Reason",
      onHand: "On hand",
      reserved: "Reserved",
      available: "Available",
      reorder: "Reorder",
      lowStock: "Low stock",
      noStock: "No stock balances.",
      noMovements: "No inventory movements.",
      noLocations: "No inventory locations.",
      addLocation: "Add location",
      editLocation: "Edit location",
      code: "Code",
      default: "Default",
    },
    users: {
      title: "Users",
      subtitle: "Invite employees and assign access roles.",
      invite: "Invite user",
      newInvitation: "New invitation",
      roles: "Roles",
      sendInvite: "Send invitation",
      name: "Name",
      actions: "Actions",
      resend: "Resend",
      deactivate: "Deactivate",
      deactivateConfirm: "Deactivate this user?",
      empty: "No users.",
    },
    roles: {
      title: "Roles and permissions",
      add: "Add role",
      name: "Role name",
      description: "Description",
      deleteConfirm: "Delete this role?",
      permissionCount: "{{count}} permissions",
      userCount: "{{count}} users",
      permissionCount_one: "{{count}} permission",
      permissionCount_other: "{{count}} permissions",
      userCount_one: "{{count}} user",
      userCount_other: "{{count}} users",
      system: {
        administrator: {
          name: "Administrator",
          description:
            "Full, unrestricted access to all functions and settings.",
        },
        employee: {
          name: "Employee",
          description:
            "Access to customer records, own requests and related files.",
        },
        office: {
          name: "Office",
          description:
            "Manages customers, requests, offers, invoices and office workflows.",
        },
      },
      permissionGroups: {
        customers: "Customers",
        requests: "Requests",
        offers: "Offers",
        invoices: "Invoices",
        payments: "Payments",
        files: "Files",
        documents: "Documents",
        users: "Users",
        employees: "Employees",
        projects: "Projects",
        teams: "Teams",
        expenses: "Expenses",
        automations: "Automations",
        time: "Time tracking",
        employee_documents: "Employee documents",
        payroll: "Payroll",
        roles: "Roles",
        settings: "Settings",
        finance: "Financial data",
        ai: "AI",
        reports: "Reports",
      },
      permissionActions: {
        view: "View",
        create: "Create",
        edit: "Edit",
        delete: "Delete",
        view_own: "View own",
        view_all: "View all",
        edit_own: "Edit own",
        edit_all: "Edit all",
        assign: "Assign",
        change_status: "Change status",
        send: "Send",
        record: "Record",
        upload: "Upload",
        download: "Download",
        deactivate: "Deactivate",
        manage: "Manage",
        manage_members: "Manage members",
        review_changes: "Review changes",
        send_password_reset: "Send password reset",
        change_email: "Change email",
        submit: "Submit",
        approve: "Approve",
        pay: "Pay",
        view_member_schedule: "View member schedules",
        view_member_time: "View member time",
        view_member_salary: "View member salary",
        view_other_managers: "View other managers",
        company_edit: "Edit company settings",
        billing_edit: "Edit billing settings",
        documents_edit: "Edit document settings",
        system_edit: "Edit system settings",
        use: "Use",
        export: "Export",
      },
    },
    expenses: {
      title: "Expenses",
      subtitle: "Create, submit and review employee expense claims.",
      newClaim: "New expense claim",
      claim: "Expense claim",
      employee: "Employee",
      status: "Status",
      total: "Total",
      currency: "Currency",
      notes: "Notes",
      items: "Expense items",
      addItem: "Add item",
      removeItem: "Remove item",
      date: "Date",
      type: "Type",
      description: "Description",
      amount: "Amount",
      kilometers: "Kilometres",
      project: "Project",
      noProject: "No project",
      receipt: "Receipt",
      uploadReceipt: "Upload receipt",
      noReceipts: "No receipts uploaded.",
      saveDraft: "Save draft",
      submit: "Submit",
      pay: "Mark paid",
      empty: "No expense claims found.",
      created: "Expense claim created.",
      saved: "Expense claim saved.",
      submitted: "Expense claim submitted.",
      paid: "Expense claim marked paid.",
      aiFallback: "AI suggestions are unavailable. You can continue manually.",
      statusLabels: {
        draft: "Draft",
        submitted: "Submitted",
        paid: "Paid",
      },
      typeLabels: {
        mileage: "Mileage",
        meal: "Meal",
        lodging: "Lodging",
        supplies: "Supplies",
        other: "Other",
      },
    },
    settings: {
      title: "Settings",
      subtitle: "Company, billing and application configuration.",
      company: "Company",
      billing: "Billing",
      addCategory: "Add category",
      addSubcategory: "Add subcategory",
      categoryName: "Category name",
      noParent: "No parent",
      documents: "Documents",
      localization: "Localization",
      aiTab: "AI",
      categories: "Categories",
      system: "System",
      ai: {
        title: "AI usage and budget",
        month: "Billing month",
        notConfigured:
          "AI is unavailable. Configure OPENROUTER_API_KEY on the server to enable it.",
        model: "Model",
        budget: "Monthly budget",
        used: "Used",
        remaining: "Remaining",
        byUser: "Usage by user",
        user: "User",
        requests: "Requests",
        tokens: "Tokens",
        cost: "Cost",
        empty: "No AI requests were made in this month.",
      },
      emailTemplates: {
        title: "Offer and invoice emails",
        hint: "Customize the email sent with each PDF. Available placeholders: {{companyName}}, {{customerName}}, {{number}}, {{title}}, {{total}}, {{dueDate}} and {{shareUrl}}.",
        language: "Template language",
        offer: "Offer email",
        invoice: "Invoice email",
        subject: "Subject",
        body: "Message",
      },
      logo: "Logo",
      legalName: "Legal name",
      tradingName: "Trading name",
      vatNumber: "VAT number",
      vacationWeeks: "Vacation weeks",
      useCompanyBranding: "Use company branding on the application",
      useCompanyBrandingHint:
        "Show the company name and logo throughout the application.",
      offerIntro: "Default offer introduction",
      footer: "Document footer",
      currency: "Currency",
      paymentDays: "Payment term days",
      bank: "Bank name",
      referenceType: "QR reference type",
      rounding: "Rounding step",
      vatRegistered: "VAT registered",
      taxRates: "Tax rates",
      rate: "Rate %",
      validity: "Offer validity days",
      offerTerms: "Default offer terms",
      invoiceTerms: "Default invoice terms",
      taxIncluded: "Prices include tax by default",
      timezone: "Timezone",
      parent: "Parent category",
      version: "Version",
      environment: "Environment",
      storage: "Storage",
      units: "Units",
      numbering: "Numbering",
      activeOnly: "Active only",
      addUnit: "Add unit",
      unitCode: "Unit code",
      unitCodeHint:
        "Short stable code used in documents, for example min or bag.",
      unitName: "Unit name",
      customTranslations: "Custom translations",
      taxRateNames: {
        standard: "Standard rate",
        reduced: "Reduced rate",
        zero: "Zero rate",
      },
      unitNames: {
        h: "Hour",
        pcs: "Piece",
        m2: "Square metre",
        m: "Metre",
        m3: "Cubic metre",
        kg: "Kilogram",
        day: "Day",
        flat: "Flat rate",
      },
      sequence: {
        customer: "Customers",
        request: "Requests",
        offer: "Offers",
        project: "Projects",
        invoice: "Invoices",
      },
    },
    teams: {
      title: "Teams",
      listTitle: "Teams",
      editorTitle: "Team editor",
      subtitle: "Organize employees into teams.",
      new: "New team",
      edit: "Edit team",
      empty: "No teams found.",
      name: "Name",
      nameRequired: "Team name is required.",
      description: "Description",
      color: "Color",
      active: "Active",
      unnamed: "Unnamed team",
      members: "Members",
      memberCount: "{{count}} members",
      membersReadOnly: "Members are managed by administrators.",
      managers: "Managers",
      managersReadOnly: "Managers are managed by administrators.",
      selectMembers: "Select members",
      selectManagers: "Select managers",
      selectHint: "Choose employees and managers.",
      managerPermissions: "Manager permissions",
      managerPermissionsHint: "Managers can see scoped team work.",
      organization: "Organization",
      organizationHint:
        "Model departments and teams, assign members, and grant permissions at any level.",
      chartView: "Chart view",
      treeView: "Tree view",
      addRoot: "Add organization",
      addChild: "Add child",
      kind: "Type",
      parent: "Parent",
      noParent: "No parent",
      role: "Role",
      permissionGrants: "Scoped permissions",
      permissionGrantsHint:
        "Grant access to this unit or to this unit and all descendants.",
      expand: "Expand",
      collapse: "Collapse",
      kinds: {
        company: "Company",
        department: "Department",
        team: "Team",
      },
      roles: {
        member: "Member",
        manager: "Manager",
      },
      scopes: {
        same_unit: "This unit",
        unit_and_descendants: "This unit and descendants",
      },
    },
    automations: {
      webhooks: "Audit webhooks",
      description: "Send signed audit events to n8n or another HTTPS endpoint.",
      add: "Add webhook",
      edit: "Edit webhook",
      empty: "No webhook endpoints configured.",
      allEvents: "All audit events (*)",
      deliveries: "deliveries",
      disable: "Disable",
      enable: "Enable",
      test: "Send test",
      rotate: "Rotate secret",
      lastDelivery: "Last delivery",
      failures: "Failures",
      events: "Events",
      event: "Event",
      attempts: "Attempts",
      response: "Response",
      url: "Endpoint URL",
      secret: "Signing secret (optional)",
      secretHint: "Leave empty to generate a strong secret.",
      selectEvents: "Select audit events",
      saveSecret: "Save the signing secret",
      secretOnce: "This secret is shown once. Store it in n8n before closing.",
      retry: "Retry",
      done: "Done",
      created: "Created",
      status: {
        pending: "Pending",
        processing: "Delivering",
        delivered: "Delivered",
        failed: "Failed",
      },
    },
    notifications: {
      subtitle: "Updates about requests, offers and invoices.",
      readAll: "Mark all as read",
      unread: "Unread",
    },
  },
  de: {
    common: {
      search: "Suchen",
      all: "Alle",
      currency: "Währung",
      date: "Datum",
      download: "Herunterladen",
      file: "Datei",
      from: "Von",
      month: "Monat",
      notes: "Notizen",
      saved: "Gespeichert",
      select: "Auswählen…",
      title: "Titel",
      to: "Bis",
      today: "Heute",
      year: "Jahr",
      name: "Name",
      phone: "Telefon",
      address: "Adresse",
      address2: "Adresszusatz",
      postalCode: "Postleitzahl",
      city: "Ort",
      language: "Sprache",
      active: "Aktiv",
      inactive: "Inaktiv",
      activate: "Aktivieren",
      deactivate: "Deaktivieren",
      configured: "Konfiguriert",
      notConfigured: "Nicht konfiguriert",
      default: "Standard",
      status: "Status",
      exportCsv: "CSV exportieren",
      selectTime: "Zeit auswählen…",
      moveUp: "Nach oben",
      moveDown: "Nach unten",
      rename: "Umbenennen",
    },
    dashboard: {
      search: "Alle Datensätze durchsuchen…",
      noResults: "Keine Ergebnisse gefunden.",
      openRequests: "Offene Anfragen",
      actionableOffers: "Offerten mit Handlungsbedarf",
      activeProjects: "Aktive Projekte",
      overdueInvoices: "Überfällige Rechnungen",
      outstanding: "Offener Betrag",
      today: "Heutige Arbeiten",
      noWorkToday: "Heute sind keine Arbeiten geplant.",
      upcoming: "Bevorstehende Arbeiten",
      noUpcoming: "Keine bevorstehenden Arbeiten.",
      activity: "Letzte Aktivitäten",
      noActivity: "Noch keine Aktivitäten.",
      actionItems: "Benötigt Ihre Aufmerksamkeit",
      attentionItem: "Hinweis",
      count: "Anzahl",
      priority: "Priorität",
      projectStatusTitle: "Projektstatus",
      projectStatusHint: "Projekte nach ihrem aktuellen Lebenszyklusstatus.",
      financialOverview: "Finanzübersicht",
      financialOverviewHint: "Fakturierte, bezahlte und offene Beträge.",
      invoiced: "Fakturiert",
      paid: "Bezahlt",
      employeeAvailability: "Mitarbeiterverfügbarkeit",
      employeeAvailabilityHint:
        "Heutige geplante Verfügbarkeit und Abwesenheiten.",
      available: "Verfügbar",
      absent: "Abwesend",
      notScheduled: "Nicht eingeplant",
      expenseOverview: "Spesenübersicht",
      expenseOverviewHint:
        "Eingereichte Mitarbeiterspesen der letzten sechs Monate.",
      catalogSales: "Katalogumsatz",
      catalogSalesHint:
        "Meistverkaufte fakturierte Katalogartikel der letzten sechs Monate.",
      projectStatuses: {
        planned: "Geplant",
        active: "Aktiv",
        on_hold: "Pausiert",
        completed: "Abgeschlossen",
        cancelled: "Storniert",
      },
      priorities: {
        low: "Niedrig",
        normal: "Normal",
        high: "Hoch",
      },
    },
    actionItems: {
      missing_prior_month_payroll_statements:
        "Fehlende Lohnabrechnungen des Vormonats",
      missing_prior_year_salary_certificates:
        "Fehlende Lohnausweise des Vorjahres",
      incomplete_employee_payroll_readiness:
        "Mitarbeitende mit fehlenden Lohndaten",
      overdue_invoices: "Überfällige Rechnungen mit offenem Betrag",
      low_stock_catalog_items: "Katalogartikel am oder unter dem Meldebestand",
      unscheduled_active_projects: "Aktive Projekte ohne Zuweisungen",
      scheduled_offboarding: "Geplante Austritte",
      incomplete_employee_documents: "Mitarbeitende ohne Dokumente",
      submitted_requests: "Eingereichte Anfragen zur Bearbeitung",
      offers_requiring_action: "Offerten mit Handlungsbedarf",
    },
    planner: {
      title: "Teamplaner",
      previous: "Vorheriger Zeitraum",
      previousShort: "Zurück",
      today: "Heute",
      next: "Nächster Zeitraum",
      nextShort: "Weiter",
      anchorDate: "Planungsdatum",
      view: "Planungsansicht",
      day: "Tag",
      week: "Woche",
      month: "Monat",
      teamMember: "Teammitglied",
      unassigned: "Nicht zugewiesen",
      noTeam: "Keine aktiven Teammitglieder.",
      holidays: "Feiertage",
      holidaysUnavailable: "Feiertage konnten nicht geladen werden.",
      newAssignment: "Neue Zuweisung",
      editAssignment: "Zuweisung bearbeiten",
      assign: "Zuweisen",
      backlog: "Ungeplante Projekte",
      backlogHelp: "Projekt auf Person und Datum ziehen oder auswählen.",
      noBacklog: "Keine ungeplanten Projekte.",
      selectProject: "Projekt auswählen",
      selectMember: "Teammitglied auswählen",
      startTime: "Beginn",
      endTime: "Ende",
      conflicts: "Planungskonflikte",
      openConflict: "Projekt öffnen",
      force: "Trotzdem planen",
    },
    customers: {
      title: "Kunden",
      subtitle: "Kundendaten, Adressen und Aktivitäten verwalten.",
      new: "Neuer Kunde",
      edit: "Kunde bearbeiten",
      empty: "Keine Kunden gefunden.",
      search: "Kunden suchen…",
      allStatuses: "Alle Status",
      contact: "Kontakt",
      address: "Adresse",
      activity: "Aktivität",
      duplicateWarning: "Mögliche doppelte Kunden gefunden.",
      private: "Privatperson",
      company: "Unternehmen",
      number: "Nummer",
      archived: "Archiviert",
      created: "Erstellt",
      type: "Kundentyp",
      companyName: "Firmenname",
      language: "Dokumentsprache",
      notes: "Interne Notizen",
      identity: "Stammdaten und Kontakt",
      contactHint: "Eine Telefonnummer oder E-Mail-Adresse ist erforderlich.",
      contactRequired: "Geben Sie eine Telefonnummer oder E-Mail-Adresse ein.",
      addresses: "Adressen",
      billingAddress: "Rechnungsadresse",
      workAddress: "Arbeitsadresse",
      sameAddress: "Rechnungsadresse als Arbeitsadresse verwenden",
      addressLine1: "Adresszeile 1",
      addressLine2: "Adresszeile 2",
      postalCode: "Postleitzahl",
      city: "Ort",
      country: "Land",
      location: {
        fill: "Aktuellen Standort verwenden",
        overwrite: "Adressfelder durch den aktuellen Standort ersetzen?",
        success: "Adresse wurde vom aktuellen Standort übernommen.",
        errors: {
          unsupported:
            "Dieser Browser unterstützt die Standortbestimmung nicht.",
          insecure:
            "Die Standortbestimmung erfordert HTTPS (oder localhost in der Entwicklung).",
          denied:
            "Der Standortzugriff wurde verweigert. Erlauben Sie ihn in den Browsereinstellungen.",
          unavailable: "Der aktuelle Standort konnte nicht bestimmt werden.",
          timeout:
            "Die Standortabfrage hat zu lange gedauert. Versuchen Sie es erneut.",
          no_address:
            "In der Nähe wurde keine Schweizer Gebäudeadresse gefunden.",
          network: "Der Schweizer Adressdienst ist nicht erreichbar.",
        },
      },
      details: "Kundendetails",
      summary: "Zusammenfassung",
      noProjects: "Keine Projekte.",
      projects: "Projekte",
    },
    requests: {
      title: "Anfragen",
      subtitle: "Kundenanfragen erfassen und prüfen.",
      new: "Neue Anfrage",
      empty: "Keine Anfragen gefunden.",
      details: "Anfragedetails",
      description: "Beschreibung",
      customerStep: "Kunde",
      workStep: "Gewünschte Arbeit",
      scheduleStep: "Termin",
      reviewStep: "Prüfen",
      shortDescription: "Kurzbeschreibung",
      selectCustomer: "Kunde auswählen",
      category: "Kategorie",
      subcategory: "Unterkategorie",
      pricing: "Preisvorstellung",
      priority: "Priorität",
      requestedDate: "Wunschtermin",
      submitOffice: "An Büro senden",
      createOffer: "Offerte erstellen",
      assigned: "Zugewiesene Mitarbeitende",
      unassigned: "Nicht zugewiesen",
      search: "Anfragen suchen…",
      allStatuses: "Alle Status",
      number: "Nummer",
      created: "Erstellt",
      captureHint:
        "Erfassen Sie die Anfrage jetzt; das Büro kann sie später kalkulieren.",
      customerAndWork: "Kunde und gewünschte Arbeit",
      createCustomer: "Neuen Kunden erfassen",
      general: "Allgemein",
      siteAddress: "Arbeitsadresse",
      expectations: "Erwartungen",
      timeMaterial: "Nach Aufwand",
      fixedPrice: "Festpreis",
      fixedAmount: "Festbetrag",
      offerRequired: "Offerte erforderlich",
      appointmentRequired: "Termin erforderlich",
      asap: "So bald wie möglich",
      desiredDate: "Wunschtermin",
      date: "Datum",
      startTime: "Startzeit (24-Stunden-Format HH:mm)",
      endTime: "Endzeit (24-Stunden-Format HH:mm)",
      scheduling: "Terminplanung",
      photos: "Fotos",
      addPhotos: "Fotos hinzufügen",
      photoHint:
        "Fügen Sie aussagekräftige Fotos des Arbeitsorts und der gewünschten Arbeit hinzu.",
      takePhoto: "Foto aufnehmen",
      uploadFiles: "Dateien hochladen",
      cameraHint:
        "Verwenden Sie die Gerätekamera oder wählen Sie vorhandene Bilddateien aus.",
      noPhotos: "Keine Fotos hinzugefügt.",
      saveDraft: "Entwurf speichern",
      ai: {
        title: "KI-gestützte Erfassung",
        hint: "Beschreiben oder diktieren Sie die Anfrage in einem separaten Arbeitsbereich und prüfen Sie anschliessend die vorgeschlagenen Formularwerte.",
        dictation: "Diktat",
        stopDictation: "Aufnahme beenden",
        cancelDictation: "Aufnahme abbrechen",
        autocomplete: "Automatisch ausfüllen",
        checkingAvailability: "KI-Verfügbarkeit wird geprüft…",
        availabilityError:
          "Die KI-Verfügbarkeit konnte nicht geprüft werden. Sie können manuell fortfahren.",
        disabled:
          "Die KI-Unterstützung ist nicht konfiguriert. Sie können manuell fortfahren.",
        noPermission:
          "Sie sind nicht berechtigt, die KI-Unterstützung zu verwenden.",
        unavailable:
          "Die KI-Unterstützung ist für dieses Konto nicht verfügbar. Sie können manuell fortfahren.",
        budgetExhausted:
          "Das monatliche KI-Budget ist aufgebraucht. Sie können manuell fortfahren.",
        budgetRemaining: "Verbleibendes KI-Budget: ${{amount}}.",
        recordingTime: "Aufnahmedauer {{time}}",
        recordingUnsupported: "Dieser Browser unterstützt keine Audioaufnahme.",
        recordingUnsupportedManual:
          "Dieser Browser unterstützt kein Diktat; automatisches Ausfüllen und manuelle Eingabe bleiben verfügbar.",
        requestingMicrophone: "Warten auf Mikrofonfreigabe…",
        recording: "Aufnahme läuft.",
        processing: "Aufnahme wird hochgeladen und transkribiert…",
        transcribing: "Transkription läuft…",
        addNotesFirst:
          "Geben Sie zuerst mindestens drei Zeichen in einer Beschreibung ein.",
        emptyRecording: "Es wurde kein Ton aufgenommen.",
        recordingCancelled: "Aufnahme abgebrochen.",
        microphoneError:
          "Das Mikrofon konnte nicht gestartet werden: {{message}}",
        dictationError:
          "Die Aufnahme konnte nicht verarbeitet werden: {{message}}",
        autocompleteError:
          "Die Anfrage konnte nicht erstellt werden: {{message}}",
        noChanges: "Die KI hat keine Änderungen vorgeschlagen.",
        transcriptLabel: "Transkript",
        dictationApplied:
          "Das Diktat wurde zu einer professionellen Anfrage zusammengefasst. Prüfen Sie die Felder vor dem Speichern.",
        autocompleteApplied:
          "Die Vorschläge wurden in die Anfrage übernommen. Prüfen Sie die Felder vor dem Speichern.",
        reviewTitle: "Vorgeschlagene Änderungen prüfen",
        reviewHint:
          "Einige Vorschläge ersetzen bereits eingegebene Informationen. Vergleichen Sie die Werte vor der Übernahme.",
        keepCurrent: "Aktuelle Werte beibehalten",
        applyChanges: "Vorgeschlagene Änderungen übernehmen",
        currentValue: "Aktuell",
        proposedValue: "Vorschlag",
        emptyValue: "Leer",
        unknownSelection: "Nicht verfügbare Auswahl",
        autocompleteTitle: "Kundenanfrage beschreiben",
        generate: "Anfrage erstellen",
        promptLabel: "Anfragedetails",
        promptHint:
          "Beschreiben Sie die gewünschten Arbeiten, den Umfang, die Terminvorstellung, die Priorität und die besprochenen Preisvorstellungen.",
        dictationTitle: "Kundenanfrage diktieren",
        dictationHint:
          "Beschreiben Sie alle relevanten Arbeiten, den Umfang, die Terminvorstellung, die Priorität und die Preisangaben. Aus der Aufnahme wird eine professionelle Zusammenfassung erstellt.",
        startDictation: "Aufnahme starten",
        processingRecording:
          "Transkription und professionelle Zusammenfassung werden erstellt…",
        fields: {
          shortDescription: "Kurzbeschreibung",
          description: "Detaillierte Beschreibung",
          category: "Kategorie",
          subcategory: "Unterkategorie",
          pricing: "Preisvorstellung",
          fixedAmount: "Festbetrag",
          scheduling: "Terminplanung",
          requestedDate: "Wunschtermin",
          startTime: "Bevorzugte Startzeit",
          endTime: "Bevorzugte Endzeit",
          priority: "Priorität",
        },
      },
    },
    offers: {
      title: "Offerten",
      subtitle: "Offerten erstellen, senden und verfolgen.",
      new: "Neue Offerte",
      edit: "Offerte bearbeiten",
      offer: "Offerte",
      empty: "Keine Offerten gefunden.",
      allStatuses: "Alle Status",
      number: "Nummer",
      validUntil: "Gültig bis",
      preview: "PDF-Vorschau",
      ready: "Bereit markieren",
      send: "Per E-Mail senden",
      accept: "Offerte annehmen",
      decline: "Als abgelehnt markieren",
      hold: "Pausieren",
      resume: "Fortsetzen",
      viewProject: "Projekt anzeigen",
      status: "Offertenstatus",
      details: "Offertendetails",
      introduction: "Einleitung",
      texts: "Bedingungen und Notizen",
      terms: "Bedingungen",
      internalNotes: "Interne Notizen",
      documentTexts: "Dokumenttexte",
      markReady: "Als bereit markieren",
      revision: "Revision",
    },
    projects: {
      title: "Projekte",
      subtitle: "Arbeit, Personen, Dokumente, Inventar und Kosten planen.",
      project: "Projekt",
      new: "Neues Projekt",
      edit: "Projekt bearbeiten",
      empty: "Keine Projekte gefunden.",
      search: "Projekte suchen…",
      allStatuses: "Alle Status",
      schedule: "Termin",
      managers: "Projektleitung",
      parent: "Übergeordnetes Projekt",
      noParent: "Kein übergeordnetes Projekt",
      selectCustomer: "Kunde auswählen",
      plannedStart: "Geplanter Beginn",
      plannedEnd: "Geplantes Ende",
      internalNotes: "Interne Notizen",
      overview: "Übersicht",
      documents: "Dokumente",
      team: "Team",
      financials: "Finanzen",
      details: "Projektdetails",
      summary: "Zusammenfassung",
      children: "Teilprojekte",
      noDescription: "Keine Beschreibung.",
      noDocuments: "Keine verknüpften Dokumente.",
      noMembers: "Keine Projektmitglieder.",
      budget: "Budget",
      revenueBudget: "Ertrag",
      laborBudget: "Arbeit",
      materialBudget: "Material",
      manualCost: "Erfasste Kosten",
      costs: "Kosten",
      noCosts: "Keine Kosten erfasst.",
      inventory: "Inventar",
      reservations: "Reservationen",
      issued: "Ausgegeben",
      remaining: "Verbleibend",
      shortage: "fehlt",
      issue: "Material ausgeben",
      release: "Reservation freigeben",
      return: "Material zurückgeben",
      returnStock: "Zurückgeben",
      noReservations: "Keine Inventarreservationen.",
      transition: {
        active: "Projekt starten",
        on_hold: "Pausieren",
        completed: "Projekt abschliessen",
        cancelled: "Projekt stornieren",
      },
    },
    invoices: {
      title: "Rechnungen",
      subtitle: "Schweizer Rechnungen ausstellen und Zahlungen verfolgen.",
      new: "Neue Rechnung",
      edit: "Rechnung bearbeiten",
      invoice: "Rechnung",
      empty: "Keine Rechnungen gefunden.",
      allStatuses: "Alle Status",
      number: "Nummer",
      date: "Rechnungsdatum",
      dueDate: "Fälligkeitsdatum",
      payment: "Zahlung",
      details: "Rechnungsdetails",
      referenceType: "Referenzart",
      paymentTerms: "Zahlungsbedingungen",
      status: "Rechnungsstatus",
      issue: "Rechnung ausstellen",
      send: "Per E-Mail senden",
      cancel: "Rechnung stornieren",
      cancelReason: "Stornierungsgrund",
      billing: "Rechnungsadresse",
      sharing: {
        title: "Sichere Rechnungslinks",
        hint: "Erstellen Sie einen privaten Download-Link, der nach drei Monaten abläuft. Der Link wird nur einmal angezeigt.",
        create: "Freigabelink erstellen",
        newLink: "Neuer Freigabelink",
        copied: "Kopiert",
        copy: "Link kopieren",
        inactive: "Inaktiver Link",
        active: "Aktiver Link",
        expires: "Läuft am {{date}} ab · {{count}} Downloads",
        revoke: "Widerrufen",
      },
    },
    payments: {
      title: "Zahlungen",
      amount: "Betrag",
      date: "Zahlungsdatum",
      method: "Zahlungsart",
      bank: "Banküberweisung",
      cash: "Bar",
      card: "Karte",
      other: "Andere",
      reference: "Referenz",
      record: "Zahlung erfassen",
      paid: "Bezahlt",
      deleteConfirm: "Diese Zahlung löschen?",
    },
    commercial: {
      positions: "Positionen",
      addPosition: "Position hinzufügen",
      type: "Typ",
      title: "Titel",
      description: "Beschreibung",
      quantity: "Menge",
      unit: "Einheit",
      unitPrice: "Einzelpreis",
      discountPercent: "Rabatt %",
      taxRate: "MWST %",
      estimatedSubtotal: "Geschätzte Zwischensumme",
      subtotal: "Zwischensumme",
      tax: "MWST",
      total: "Total",
      terms: "Bedingungen",
      notes: "Interne Notizen",
      customerNotes: "Kundennotizen",
      previewCurrent: "Aktuelles PDF ansehen",
      issuedPdf: "Ausgestelltes PDF",
      validUntil: "Gültig bis",
      schedule: "Termin",
      start: "Beginn",
      end: "Ende",
      priority: "Priorität",
      position: "Position",
      work: "Arbeit",
      product: "Produkt",
      material: "Material",
      flatRate: "Pauschale",
      text: "Text",
      discount: "Rabatt %",
      catalogItem: "Katalogartikel",
      selectCatalogItem: "Artikel auswählen…",
      addFromCatalog: "Aus Katalog hinzufügen",
      trackedLineLocked:
        "Typ und Einheit sind gesperrt, solange dieser Lagerartikel verknüpft ist.",
      makeManual: "Manuell bearbeiten",
      insufficientAvailability:
        "Die angeforderte Menge übersteigt den verfügbaren Bestand.",
    },
    catalog: {
      title: "Inventar",
      subtitle: "Artikel, Pakete, Bestände und Lagerorte verwalten.",
      add: "Artikel hinzufügen",
      edit: "Artikel bearbeiten",
      empty: "Keine Katalogartikel.",
      inactive: "Inaktive anzeigen",
      name: "Name",
      sku: "Artikelnummer",
      type: "Typ",
      unit: "Einheit",
      price: "Einzelpreis",
      tax: "MWST %",
      items: "Artikel",
      barcode: "Barcode",
      stockTracked: "Lagerbestand führen",
      defaultUnitCost: "Standard-Einstandspreis",
      reorderPoint: "Meldebestand",
    },
    inventory: {
      stock: "Bestand",
      movements: "Bewegungen",
      locations: "Lagerorte",
      location: "Lagerort",
      allLocations: "Alle Lagerorte",
      allMovements: "Alle Bewegungen",
      receive: "Wareneingang",
      receipt: "Wareneingang",
      adjust: "Korrigieren",
      adjustment: "Bestand korrigieren",
      transfer: "Umlagern",
      fromLocation: "Von Lagerort",
      toLocation: "Zu Lagerort",
      direction: "Richtung",
      in: "Erhöhen",
      out: "Verringern",
      quantity: "Menge",
      unitCost: "Einstandspreis",
      reason: "Grund",
      onHand: "Bestand",
      reserved: "Reserviert",
      available: "Verfügbar",
      reorder: "Nachbestellung",
      lowStock: "Meldebestand",
      noStock: "Keine Bestände.",
      noMovements: "Keine Lagerbewegungen.",
      noLocations: "Keine Lagerorte.",
      addLocation: "Lagerort hinzufügen",
      editLocation: "Lagerort bearbeiten",
      code: "Code",
      default: "Standard",
    },
    users: {
      title: "Benutzer",
      subtitle: "Mitarbeitende einladen und Rollen zuweisen.",
      invite: "Benutzer einladen",
      newInvitation: "Neue Einladung",
      roles: "Rollen",
      sendInvite: "Einladung senden",
      name: "Name",
      actions: "Aktionen",
      resend: "Erneut senden",
      deactivate: "Deaktivieren",
      deactivateConfirm: "Diesen Benutzer deaktivieren?",
      empty: "Keine Benutzer.",
    },
    roles: {
      title: "Rollen und Berechtigungen",
      add: "Rolle hinzufügen",
      name: "Rollenname",
      description: "Beschreibung",
      deleteConfirm: "Diese Rolle löschen?",
      permissionCount: "{{count}} Berechtigungen",
      userCount: "{{count}} Benutzer",
      permissionCount_one: "{{count}} Berechtigung",
      permissionCount_other: "{{count}} Berechtigungen",
      userCount_one: "{{count}} Benutzer",
      userCount_other: "{{count}} Benutzer",
      system: {
        administrator: {
          name: "Administrator",
          description:
            "Vollständiger, uneingeschränkter Zugriff auf alle Funktionen und Einstellungen.",
        },
        employee: {
          name: "Mitarbeitende",
          description:
            "Zugriff auf Kundendaten, eigene Anfragen und zugehörige Dateien.",
        },
        office: {
          name: "Büro",
          description:
            "Verwaltet Kunden, Anfragen, Offerten, Rechnungen und Büroabläufe.",
        },
      },
      permissionGroups: {
        customers: "Kunden",
        requests: "Anfragen",
        offers: "Offerten",
        invoices: "Rechnungen",
        payments: "Zahlungen",
        files: "Dateien",
        documents: "Dokumente",
        users: "Benutzer",
        employees: "Mitarbeitende",
        projects: "Projekte",
        teams: "Teams",
        expenses: "Spesen",
        automations: "Automatisierungen",
        time: "Zeiterfassung",
        employee_documents: "Mitarbeiterdokumente",
        payroll: "Lohnbuchhaltung",
        roles: "Rollen",
        settings: "Einstellungen",
        finance: "Finanzdaten",
        ai: "KI",
        reports: "Berichte",
      },
      permissionActions: {
        view: "Anzeigen",
        create: "Erstellen",
        edit: "Bearbeiten",
        delete: "Löschen",
        view_own: "Eigene anzeigen",
        view_all: "Alle anzeigen",
        edit_own: "Eigene bearbeiten",
        edit_all: "Alle bearbeiten",
        assign: "Zuweisen",
        change_status: "Status ändern",
        send: "Senden",
        record: "Erfassen",
        upload: "Hochladen",
        download: "Herunterladen",
        deactivate: "Deaktivieren",
        manage: "Verwalten",
        manage_members: "Mitglieder verwalten",
        review_changes: "Änderungen prüfen",
        send_password_reset: "Passwort zurücksetzen senden",
        change_email: "E-Mail ändern",
        submit: "Einreichen",
        approve: "Genehmigen",
        pay: "Auszahlen",
        view_member_schedule: "Mitgliederpläne anzeigen",
        view_member_time: "Mitgliederzeit anzeigen",
        view_member_salary: "Mitgliederlöhne anzeigen",
        view_other_managers: "Andere Manager anzeigen",
        company_edit: "Firmeneinstellungen bearbeiten",
        billing_edit: "Abrechnungseinstellungen bearbeiten",
        documents_edit: "Dokumenteinstellungen bearbeiten",
        system_edit: "Systemeinstellungen bearbeiten",
        use: "Verwenden",
        export: "Exportieren",
      },
    },
    expenses: {
      title: "Spesen",
      subtitle: "Spesen erfassen, einreichen und prüfen.",
      newClaim: "Neue Spesenabrechnung",
      claim: "Spesenabrechnung",
      employee: "Mitarbeitende",
      status: "Status",
      total: "Total",
      currency: "Währung",
      notes: "Notizen",
      items: "Spesenpositionen",
      addItem: "Position hinzufügen",
      removeItem: "Position entfernen",
      date: "Datum",
      type: "Art",
      description: "Beschreibung",
      amount: "Betrag",
      kilometers: "Kilometer",
      project: "Projekt",
      noProject: "Kein Projekt",
      receipt: "Beleg",
      uploadReceipt: "Beleg hochladen",
      noReceipts: "Keine Belege hochgeladen.",
      saveDraft: "Entwurf speichern",
      submit: "Einreichen",
      pay: "Als bezahlt markieren",
      empty: "Keine Spesenabrechnungen gefunden.",
      created: "Spesenabrechnung erstellt.",
      saved: "Spesenabrechnung gespeichert.",
      submitted: "Spesenabrechnung eingereicht.",
      paid: "Spesenabrechnung als bezahlt markiert.",
      aiFallback:
        "KI-Vorschläge sind nicht verfügbar. Sie können manuell fortfahren.",
      statusLabels: {
        draft: "Entwurf",
        submitted: "Eingereicht",
        paid: "Bezahlt",
      },
      typeLabels: {
        mileage: "Kilometer",
        meal: "Verpflegung",
        lodging: "Übernachtung",
        supplies: "Material",
        other: "Sonstiges",
      },
    },
    settings: {
      title: "Einstellungen",
      subtitle: "Firma, Abrechnung und Anwendung konfigurieren.",
      company: "Firma",
      billing: "Abrechnung",
      documents: "Dokumente",
      localization: "Lokalisierung",
      aiTab: "KI",
      categories: "Kategorien",
      addCategory: "Kategorie hinzufügen",
      addSubcategory: "Unterkategorie hinzufügen",
      categoryName: "Kategoriename",
      noParent: "Keine übergeordnete Kategorie",
      system: "System",
      ai: {
        title: "KI-Nutzung und Budget",
        month: "Abrechnungsmonat",
        notConfigured:
          "KI ist nicht verfügbar. Konfigurieren Sie OPENROUTER_API_KEY auf dem Server.",
        model: "Modell",
        budget: "Monatsbudget",
        used: "Verwendet",
        remaining: "Verbleibend",
        byUser: "Nutzung pro Benutzer",
        user: "Benutzer",
        requests: "Anfragen",
        tokens: "Tokens",
        cost: "Kosten",
        empty: "In diesem Monat wurden keine KI-Anfragen gestellt.",
      },
      emailTemplates: {
        title: "E-Mails für Offerten und Rechnungen",
        hint: "Passen Sie die E-Mail zu jedem PDF an. Verfügbare Platzhalter: {{companyName}}, {{customerName}}, {{number}}, {{title}}, {{total}}, {{dueDate}} und {{shareUrl}}.",
        language: "Vorlagensprache",
        offer: "Offerten-E-Mail",
        invoice: "Rechnungs-E-Mail",
        subject: "Betreff",
        body: "Nachricht",
      },
      logo: "Logo",
      legalName: "Firmenname",
      tradingName: "Anzeigename",
      vatNumber: "MWST-Nummer",
      vacationWeeks: "Ferienwochen",
      useCompanyBranding: "Firmenauftritt in der Anwendung verwenden",
      useCompanyBrandingHint:
        "Firmenname und Logo in der gesamten Anwendung anzeigen.",
      offerIntro: "Standard-Offerteneinleitung",
      footer: "Dokumentfusszeile",
      currency: "Währung",
      paymentDays: "Zahlungsfrist (Tage)",
      bank: "Bankname",
      referenceType: "QR-Referenzart",
      rounding: "Rundungsschritt",
      vatRegistered: "MWST-pflichtig",
      taxRates: "Steuersätze",
      rate: "Satz %",
      validity: "Offertengültigkeit (Tage)",
      offerTerms: "Standard-Offertenbedingungen",
      invoiceTerms: "Standard-Rechnungsbedingungen",
      taxIncluded: "Preise standardmässig inklusive Steuer",
      timezone: "Zeitzone",
      parent: "Übergeordnete Kategorie",
      version: "Version",
      environment: "Umgebung",
      storage: "Speicher",
      units: "Einheiten",
      numbering: "Nummerierung",
      activeOnly: "Nur aktive",
      addUnit: "Einheit hinzufügen",
      unitCode: "Einheitscode",
      unitCodeHint:
        "Kurzer stabiler Code für Dokumente, zum Beispiel min oder Sack.",
      unitName: "Einheitsname",
      customTranslations: "Eigene Übersetzungen",
      taxRateNames: {
        standard: "Normalsatz",
        reduced: "Reduzierter Satz",
        zero: "Nullsatz",
      },
      unitNames: {
        h: "Stunde",
        pcs: "Stück",
        m2: "Quadratmeter",
        m: "Meter",
        m3: "Kubikmeter",
        kg: "Kilogramm",
        day: "Tag",
        flat: "Pauschale",
      },
      sequence: {
        customer: "Kunden",
        request: "Anfragen",
        offer: "Offerten",
        project: "Projekte",
        invoice: "Rechnungen",
      },
    },
    teams: {
      title: "Teams",
      listTitle: "Teams",
      editorTitle: "Team-Editor",
      subtitle: "Mitarbeitende in Teams organisieren.",
      new: "Neues Team",
      edit: "Team bearbeiten",
      empty: "Keine Teams gefunden.",
      name: "Name",
      nameRequired: "Teamname ist erforderlich.",
      description: "Beschreibung",
      color: "Farbe",
      active: "Aktiv",
      unnamed: "Unbenanntes Team",
      members: "Mitglieder",
      memberCount: "{{count}} Mitglieder",
      membersReadOnly: "Mitglieder werden von Administratoren verwaltet.",
      managers: "Manager",
      managersReadOnly: "Manager werden von Administratoren verwaltet.",
      selectMembers: "Mitglieder auswählen",
      selectManagers: "Manager auswählen",
      selectHint: "Mitarbeitende und Manager auswählen.",
      managerPermissions: "Manager-Berechtigungen",
      managerPermissionsHint: "Manager sehen den Bereich ihres Teams.",
      organization: "Organisation",
      organizationHint:
        "Abteilungen und Teams strukturieren, Mitglieder zuweisen und Berechtigungen pro Ebene vergeben.",
      chartView: "Organigramm",
      treeView: "Baumansicht",
      addRoot: "Organisation hinzufügen",
      addChild: "Untergeordnete Einheit",
      kind: "Typ",
      parent: "Übergeordnete Einheit",
      noParent: "Keine übergeordnete Einheit",
      role: "Rolle",
      permissionGrants: "Bereichsberechtigungen",
      permissionGrantsHint:
        "Zugriff auf diese Einheit oder auf diese Einheit mit allen Untereinheiten gewähren.",
      expand: "Aufklappen",
      collapse: "Zuklappen",
      kinds: {
        company: "Unternehmen",
        department: "Abteilung",
        team: "Team",
      },
      roles: {
        member: "Mitglied",
        manager: "Manager",
      },
      scopes: {
        same_unit: "Diese Einheit",
        unit_and_descendants: "Diese Einheit und Untereinheiten",
      },
    },
    automations: {
      webhooks: "Audit-Webhooks",
      description:
        "Signierte Audit-Ereignisse an n8n oder einen anderen HTTPS-Endpunkt senden.",
      add: "Webhook hinzufügen",
      edit: "Webhook bearbeiten",
      empty: "Keine Webhook-Endpunkte konfiguriert.",
      allEvents: "Alle Audit-Ereignisse (*)",
      deliveries: "Zustellungen",
      disable: "Deaktivieren",
      enable: "Aktivieren",
      test: "Test senden",
      rotate: "Geheimnis rotieren",
      lastDelivery: "Letzte Zustellung",
      failures: "Fehler",
      events: "Ereignisse",
      event: "Ereignis",
      attempts: "Versuche",
      response: "Antwort",
      url: "Endpunkt-URL",
      secret: "Signatur-Geheimnis (optional)",
      secretHint: "Leer lassen, um ein starkes Geheimnis zu erzeugen.",
      selectEvents: "Audit-Ereignisse auswählen",
      saveSecret: "Signatur-Geheimnis speichern",
      secretOnce:
        "Dieses Geheimnis wird nur einmal angezeigt. Vor dem Schliessen in n8n speichern.",
      retry: "Erneut versuchen",
      done: "Fertig",
      created: "Erstellt",
      status: {
        pending: "Ausstehend",
        processing: "Wird zugestellt",
        delivered: "Zugestellt",
        failed: "Fehlgeschlagen",
      },
    },
    notifications: {
      subtitle: "Aktualisierungen zu Anfragen, Offerten und Rechnungen.",
      readAll: "Alle als gelesen markieren",
      unread: "Ungelesen",
    },
  },
  fr: {
    common: {
      search: "Rechercher",
      all: "Tous",
      currency: "Devise",
      date: "Date",
      download: "Télécharger",
      file: "Fichier",
      from: "De",
      month: "Mois",
      notes: "Notes",
      saved: "Enregistré",
      select: "Sélectionner…",
      title: "Titre",
      to: "À",
      today: "Aujourd’hui",
      year: "Année",
      name: "Nom",
      phone: "Téléphone",
      address: "Adresse",
      address2: "Complément d’adresse",
      postalCode: "Code postal",
      city: "Ville",
      language: "Langue",
      active: "Actif",
      inactive: "Inactif",
      activate: "Activer",
      deactivate: "Désactiver",
      configured: "Configuré",
      notConfigured: "Non configuré",
      default: "Par défaut",
      status: "Statut",
      exportCsv: "Exporter en CSV",
      selectTime: "Sélectionner une heure…",
      moveUp: "Monter",
      moveDown: "Descendre",
      rename: "Renommer",
    },
    dashboard: {
      search: "Rechercher dans toutes les données…",
      noResults: "Aucun résultat.",
      openRequests: "Demandes ouvertes",
      actionableOffers: "Offres à traiter",
      activeProjects: "Projets actifs",
      overdueInvoices: "Factures échues",
      outstanding: "Montant en suspens",
      today: "Travaux du jour",
      noWorkToday: "Aucun travail prévu aujourd’hui.",
      upcoming: "Travaux à venir",
      noUpcoming: "Aucun travail à venir.",
      activity: "Activité récente",
      noActivity: "Aucune activité.",
      actionItems: "Nécessite votre attention",
      attentionItem: "Élément à traiter",
      count: "Nombre",
      priority: "Priorité",
      projectStatusTitle: "Statut des projets",
      projectStatusHint: "Projets selon leur état actuel.",
      financialOverview: "Aperçu financier",
      financialOverviewHint: "Montants facturés, payés et en suspens.",
      invoiced: "Facturé",
      paid: "Payé",
      employeeAvailability: "Disponibilité des employés",
      employeeAvailabilityHint:
        "Disponibilités planifiées et absences du jour.",
      available: "Disponible",
      absent: "Absent",
      notScheduled: "Non planifié",
      expenseOverview: "Aperçu des dépenses",
      expenseOverviewHint: "Dépenses soumises au cours des six derniers mois.",
      catalogSales: "Ventes du catalogue",
      catalogSalesHint: "Articles du catalogue les plus facturés sur six mois.",
      projectStatuses: {
        planned: "Planifié",
        active: "Actif",
        on_hold: "En pause",
        completed: "Terminé",
        cancelled: "Annulé",
      },
      priorities: {
        low: "Faible",
        normal: "Normale",
        high: "Élevée",
      },
    },
    actionItems: {
      missing_prior_month_payroll_statements:
        "Décomptes de salaire manquants du mois précédent",
      missing_prior_year_salary_certificates:
        "Certificats de salaire manquants de l’année précédente",
      incomplete_employee_payroll_readiness:
        "Employés avec des données salariales manquantes",
      overdue_invoices: "Factures échues avec un solde impayé",
      low_stock_catalog_items:
        "Articles au niveau ou sous le seuil de commande",
      unscheduled_active_projects: "Projets actifs sans affectations",
      scheduled_offboarding: "Départs d’employés planifiés",
      incomplete_employee_documents: "Employés sans documents",
      submitted_requests: "Demandes soumises en attente de traitement",
      offers_requiring_action: "Offres nécessitant une action",
    },
    planner: {
      title: "Planificateur d’équipe",
      previous: "Période précédente",
      previousShort: "Précédent",
      today: "Aujourd’hui",
      next: "Période suivante",
      nextShort: "Suivant",
      anchorDate: "Date de planification",
      view: "Vue du planificateur",
      day: "Jour",
      week: "Semaine",
      month: "Mois",
      teamMember: "Membre de l’équipe",
      unassigned: "Non attribué",
      noTeam: "Aucun membre d’équipe actif.",
      holidays: "Jours fériés",
      holidaysUnavailable: "Les jours fériés n’ont pas pu être chargés.",
      newAssignment: "Nouvelle affectation",
      editAssignment: "Modifier l’affectation",
      assign: "Affecter",
      backlog: "Projets non planifiés",
      backlogHelp:
        "Glissez un projet sur une personne et une date, ou sélectionnez-le.",
      noBacklog: "Aucun projet non planifié.",
      selectProject: "Sélectionner un projet",
      selectMember: "Sélectionner un membre",
      startTime: "Début",
      endTime: "Fin",
      conflicts: "Conflits de planification",
      openConflict: "Ouvrir le projet",
      force: "Planifier quand même",
    },
    customers: {
      title: "Clients",
      subtitle: "Gérer les clients, adresses et activités.",
      new: "Nouveau client",
      edit: "Modifier le client",
      empty: "Aucun client trouvé.",
      search: "Rechercher des clients…",
      allStatuses: "Tous les statuts",
      contact: "Contact",
      address: "Adresse",
      activity: "Activité",
      duplicateWarning: "Doublons potentiels détectés.",
      private: "Particulier",
      company: "Entreprise",
      number: "Numéro",
      archived: "Archivé",
      created: "Créé le",
      type: "Type de client",
      companyName: "Nom de l’entreprise",
      language: "Langue des documents",
      notes: "Notes internes",
      identity: "Identité et coordonnées",
      contactHint: "Un numéro de téléphone ou une adresse e-mail est requis.",
      contactRequired:
        "Saisissez un numéro de téléphone ou une adresse e-mail.",
      addresses: "Adresses",
      billingAddress: "Adresse de facturation",
      workAddress: "Adresse des travaux",
      sameAddress: "Utiliser l’adresse de facturation pour les travaux",
      addressLine1: "Adresse",
      addressLine2: "Complément d’adresse",
      postalCode: "Code postal",
      city: "Ville",
      country: "Pays",
      location: {
        fill: "Utiliser la position actuelle",
        overwrite:
          "Remplacer les champs d’adresse par votre position actuelle ?",
        success: "Adresse renseignée à partir de votre position actuelle.",
        errors: {
          unsupported:
            "La géolocalisation n’est pas prise en charge par ce navigateur.",
          insecure:
            "La géolocalisation nécessite HTTPS (ou localhost en développement).",
          denied:
            "L’accès à la position a été refusé. Autorisez-le dans les paramètres du navigateur.",
          unavailable: "Votre position actuelle n’a pas pu être déterminée.",
          timeout: "La géolocalisation a expiré. Réessayez.",
          no_address:
            "Aucune adresse de bâtiment suisse n’a été trouvée à proximité.",
          network: "Le service suisse d’adresses est inaccessible.",
        },
      },
      details: "Détails du client",
      summary: "Récapitulatif",
      noProjects: "Aucun projet.",
      projects: "Projets",
    },
    requests: {
      title: "Demandes",
      subtitle: "Saisir et examiner les demandes clients.",
      new: "Nouvelle demande",
      empty: "Aucune demande trouvée.",
      details: "Détails de la demande",
      description: "Description",
      customerStep: "Client",
      workStep: "Travaux demandés",
      scheduleStep: "Planification",
      reviewStep: "Vérification",
      shortDescription: "Description courte",
      selectCustomer: "Sélectionner un client",
      category: "Catégorie",
      subcategory: "Sous-catégorie",
      pricing: "Attente de prix",
      priority: "Priorité",
      requestedDate: "Date souhaitée",
      submitOffice: "Envoyer au bureau",
      createOffer: "Créer une offre",
      assigned: "Employés assignés",
      unassigned: "Non assigné",
      search: "Rechercher des demandes…",
      allStatuses: "Tous les statuts",
      number: "Numéro",
      created: "Créée le",
      captureHint:
        "Saisissez la demande maintenant ; le bureau pourra la chiffrer ultérieurement.",
      customerAndWork: "Client et travaux demandés",
      createCustomer: "Créer un nouveau client",
      general: "Général",
      siteAddress: "Adresse des travaux",
      expectations: "Attentes",
      timeMaterial: "Temps et matériel",
      fixedPrice: "Prix forfaitaire",
      fixedAmount: "Montant forfaitaire",
      offerRequired: "Offre requise",
      appointmentRequired: "Rendez-vous requis",
      asap: "Dès que possible",
      desiredDate: "Date souhaitée",
      date: "Date",
      startTime: "Heure de début (format 24 h HH:mm)",
      endTime: "Heure de fin (format 24 h HH:mm)",
      scheduling: "Planification",
      photos: "Photos",
      addPhotos: "Ajouter des photos",
      photoHint:
        "Ajoutez des photos explicites du lieu et des travaux demandés.",
      takePhoto: "Prendre une photo",
      uploadFiles: "Téléverser des fichiers",
      cameraHint:
        "Utilisez l’appareil photo de votre appareil ou sélectionnez des images existantes.",
      noPhotos: "Aucune photo ajoutée.",
      saveDraft: "Enregistrer le brouillon",
      ai: {
        title: "Saisie assistée par IA",
        hint: "Décrivez ou dictez la demande dans un espace séparé, puis vérifiez les valeurs proposées pour le formulaire.",
        dictation: "Dictée",
        stopDictation: "Arrêter l’enregistrement",
        cancelDictation: "Annuler l’enregistrement",
        autocomplete: "Remplissage automatique",
        checkingAvailability: "Vérification de la disponibilité de l’IA…",
        availabilityError:
          "La disponibilité de l’IA n’a pas pu être vérifiée. Vous pouvez continuer manuellement.",
        disabled:
          "L’assistance IA n’est pas configurée. Vous pouvez continuer manuellement.",
        noPermission: "Vous n’êtes pas autorisé à utiliser l’assistance IA.",
        unavailable:
          "L’assistance IA n’est pas disponible pour ce compte. Vous pouvez continuer manuellement.",
        budgetExhausted:
          "Le budget IA mensuel est épuisé. Vous pouvez continuer manuellement.",
        budgetRemaining: "Budget IA restant : ${{amount}}.",
        recordingTime: "Durée de l’enregistrement {{time}}",
        recordingUnsupported:
          "Ce navigateur ne prend pas en charge l’enregistrement audio.",
        recordingUnsupportedManual:
          "Ce navigateur ne prend pas en charge la dictée ; la saisie automatique et manuelle restent disponibles.",
        requestingMicrophone: "En attente de l’autorisation du microphone…",
        recording: "Enregistrement en cours.",
        processing: "Téléversement et transcription de l’enregistrement…",
        transcribing: "Transcription…",
        addNotesFirst:
          "Saisissez d’abord au moins trois caractères dans une description.",
        emptyRecording: "Aucun son n’a été enregistré.",
        recordingCancelled: "Enregistrement annulé.",
        microphoneError: "Le microphone n’a pas pu être démarré : {{message}}",
        dictationError: "L’enregistrement n’a pas pu être traité : {{message}}",
        autocompleteError: "La demande n’a pas pu être générée : {{message}}",
        noChanges: "L’IA n’a proposé aucune modification.",
        transcriptLabel: "Transcription",
        dictationApplied:
          "La dictée a été résumée dans la demande. Vérifiez les champs avant d’enregistrer.",
        autocompleteApplied:
          "Les suggestions ont été ajoutées à la demande. Vérifiez les champs avant d’enregistrer.",
        reviewTitle: "Vérifier les modifications proposées",
        reviewHint:
          "Certaines suggestions remplacent des informations déjà saisies. Comparez les valeurs avant de les appliquer.",
        keepCurrent: "Conserver les valeurs actuelles",
        applyChanges: "Appliquer les modifications proposées",
        currentValue: "Actuel",
        proposedValue: "Proposé",
        emptyValue: "Vide",
        unknownSelection: "Sélection indisponible",
        autocompleteTitle: "Décrire la demande du client",
        generate: "Générer la demande",
        promptLabel: "Détails de la demande",
        promptHint:
          "Indiquez les travaux demandés, leur étendue, le calendrier, la priorité et les attentes de prix convenues.",
        dictationTitle: "Dicter la demande du client",
        dictationHint:
          "Décrivez tous les travaux pertinents, leur étendue, le calendrier, la priorité et les informations de prix. Un résumé professionnel sera généré à partir de l’enregistrement.",
        startDictation: "Démarrer l’enregistrement",
        processingRecording:
          "Transcription et préparation d’un résumé professionnel…",
        fields: {
          shortDescription: "Description courte",
          description: "Description détaillée",
          category: "Catégorie",
          subcategory: "Sous-catégorie",
          pricing: "Attente de prix",
          fixedAmount: "Montant forfaitaire",
          scheduling: "Planification",
          requestedDate: "Date souhaitée",
          startTime: "Heure de début souhaitée",
          endTime: "Heure de fin souhaitée",
          priority: "Priorité",
        },
      },
    },
    offers: {
      title: "Offres",
      subtitle: "Préparer, envoyer et suivre les offres.",
      new: "Nouvelle offre",
      edit: "Modifier l’offre",
      offer: "Offre",
      empty: "Aucune offre trouvée.",
      allStatuses: "Tous les statuts",
      number: "Numéro",
      validUntil: "Valable jusqu’au",
      preview: "Aperçu PDF",
      ready: "Marquer prête",
      send: "Envoyer par e-mail",
      accept: "Accepter l’offre",
      decline: "Marquer comme refusée",
      hold: "Mettre en attente",
      resume: "Reprendre",
      viewProject: "Voir le projet",
      status: "Statut de l’offre",
      details: "Détails de l’offre",
      introduction: "Introduction",
      texts: "Conditions et notes",
      terms: "Conditions",
      internalNotes: "Notes internes",
      documentTexts: "Textes du document",
      markReady: "Marquer comme prête",
      revision: "Révision",
    },
    projects: {
      title: "Projets",
      subtitle:
        "Planifier le travail, les personnes, les documents, le stock et les coûts.",
      project: "Projet",
      new: "Nouveau projet",
      edit: "Modifier le projet",
      empty: "Aucun projet trouvé.",
      search: "Rechercher des projets…",
      allStatuses: "Tous les statuts",
      schedule: "Planification",
      managers: "Responsables",
      parent: "Projet parent",
      noParent: "Aucun projet parent",
      selectCustomer: "Sélectionner un client",
      plannedStart: "Début prévu",
      plannedEnd: "Fin prévue",
      internalNotes: "Notes internes",
      overview: "Vue d’ensemble",
      documents: "Documents",
      team: "Équipe",
      financials: "Finances",
      details: "Détails du projet",
      summary: "Récapitulatif",
      children: "Sous-projets",
      noDescription: "Aucune description.",
      noDocuments: "Aucun document lié.",
      noMembers: "Aucun membre du projet.",
      budget: "Budget",
      revenueBudget: "Revenus",
      laborBudget: "Main-d’œuvre",
      materialBudget: "Matériel",
      manualCost: "Coûts enregistrés",
      costs: "Coûts",
      noCosts: "Aucun coût enregistré.",
      inventory: "Stock",
      reservations: "Réservations",
      issued: "Sorti",
      remaining: "Restant",
      shortage: "manquant",
      issue: "Sortir du stock",
      release: "Libérer la réservation",
      return: "Retourner au stock",
      returnStock: "Retourner",
      noReservations: "Aucune réservation de stock.",
      transition: {
        active: "Démarrer le projet",
        on_hold: "Mettre en attente",
        completed: "Terminer le projet",
        cancelled: "Annuler le projet",
      },
    },
    invoices: {
      title: "Factures",
      subtitle: "Émettre des factures suisses et suivre les paiements.",
      new: "Nouvelle facture",
      edit: "Modifier la facture",
      invoice: "Facture",
      empty: "Aucune facture trouvée.",
      allStatuses: "Tous les statuts",
      number: "Numéro",
      date: "Date de facture",
      dueDate: "Échéance",
      payment: "Paiement",
      details: "Détails de la facture",
      referenceType: "Type de référence",
      paymentTerms: "Conditions de paiement",
      status: "Statut de la facture",
      issue: "Émettre la facture",
      send: "Envoyer par e-mail",
      cancel: "Annuler la facture",
      cancelReason: "Motif d’annulation",
      billing: "Adresse de facturation",
      sharing: {
        title: "Liens de facture sécurisés",
        hint: "Créez un lien de téléchargement privé qui expire après trois mois. Le lien n’est affiché qu’une seule fois.",
        create: "Créer un lien de partage",
        newLink: "Nouveau lien de partage",
        copied: "Copié",
        copy: "Copier le lien",
        inactive: "Lien inactif",
        active: "Lien actif",
        expires: "Expire le {{date}} · {{count}} téléchargements",
        revoke: "Révoquer",
      },
    },
    payments: {
      title: "Paiements",
      amount: "Montant",
      date: "Date de paiement",
      method: "Mode",
      bank: "Virement bancaire",
      cash: "Espèces",
      card: "Carte",
      other: "Autre",
      reference: "Référence",
      record: "Enregistrer le paiement",
      paid: "Payé",
      deleteConfirm: "Supprimer ce paiement ?",
    },
    commercial: {
      positions: "Postes",
      addPosition: "Ajouter un poste",
      type: "Type",
      title: "Titre",
      description: "Description",
      quantity: "Quantité",
      unit: "Unité",
      unitPrice: "Prix unitaire",
      discountPercent: "Remise %",
      taxRate: "TVA %",
      estimatedSubtotal: "Sous-total estimé",
      subtotal: "Sous-total",
      tax: "TVA",
      total: "Total",
      terms: "Conditions",
      notes: "Notes internes",
      customerNotes: "Notes visibles par le client",
      previewCurrent: "Prévisualiser le PDF actuel",
      issuedPdf: "PDF émis",
      validUntil: "Valable jusqu’au",
      schedule: "Planification",
      start: "Début",
      end: "Fin",
      priority: "Priorité",
      position: "Poste",
      work: "Travail",
      product: "Produit",
      material: "Matériau",
      flatRate: "Forfait",
      text: "Texte",
      discount: "Remise %",
      catalogItem: "Article du catalogue",
      selectCatalogItem: "Sélectionner un article…",
      addFromCatalog: "Ajouter depuis le catalogue",
      trackedLineLocked:
        "Le type et l’unité sont verrouillés tant que cet article suivi est lié.",
      makeManual: "Rendre manuel",
      insufficientAvailability:
        "La quantité demandée dépasse le stock disponible.",
    },
    catalog: {
      title: "Stock",
      subtitle:
        "Gérer les articles, les forfaits, les stocks et les emplacements.",
      add: "Ajouter un article",
      edit: "Modifier l’article",
      empty: "Aucun article.",
      inactive: "Afficher les inactifs",
      name: "Nom",
      sku: "Référence",
      type: "Type",
      unit: "Unité",
      price: "Prix unitaire",
      tax: "TVA %",
      items: "Articles",
      barcode: "Code-barres",
      stockTracked: "Suivre le stock",
      defaultUnitCost: "Coût unitaire par défaut",
      reorderPoint: "Seuil de réapprovisionnement",
    },
    inventory: {
      stock: "Stock",
      movements: "Mouvements",
      locations: "Emplacements",
      location: "Emplacement",
      allLocations: "Tous les emplacements",
      allMovements: "Tous les mouvements",
      receive: "Réceptionner",
      receipt: "Réception de stock",
      adjust: "Ajuster",
      adjustment: "Ajuster le stock",
      transfer: "Transférer",
      fromLocation: "Emplacement source",
      toLocation: "Emplacement cible",
      direction: "Direction",
      in: "Augmenter",
      out: "Diminuer",
      quantity: "Quantité",
      unitCost: "Coût unitaire",
      reason: "Motif",
      onHand: "En stock",
      reserved: "Réservé",
      available: "Disponible",
      reorder: "Réapprovisionnement",
      lowStock: "Stock bas",
      noStock: "Aucun solde de stock.",
      noMovements: "Aucun mouvement de stock.",
      noLocations: "Aucun emplacement.",
      addLocation: "Ajouter un emplacement",
      editLocation: "Modifier l’emplacement",
      code: "Code",
      default: "Par défaut",
    },
    users: {
      title: "Utilisateurs",
      subtitle: "Inviter des employés et attribuer des rôles.",
      invite: "Inviter un utilisateur",
      newInvitation: "Nouvelle invitation",
      roles: "Rôles",
      sendInvite: "Envoyer l’invitation",
      name: "Nom",
      actions: "Actions",
      resend: "Renvoyer",
      deactivate: "Désactiver",
      deactivateConfirm: "Désactiver cet utilisateur ?",
      empty: "Aucun utilisateur.",
    },
    roles: {
      title: "Rôles et autorisations",
      add: "Ajouter un rôle",
      name: "Nom du rôle",
      description: "Description",
      deleteConfirm: "Supprimer ce rôle ?",
      permissionCount: "{{count}} autorisations",
      userCount: "{{count}} utilisateurs",
      permissionCount_one: "{{count}} autorisation",
      permissionCount_other: "{{count}} autorisations",
      userCount_one: "{{count}} utilisateur",
      userCount_other: "{{count}} utilisateurs",
      system: {
        administrator: {
          name: "Administrateur",
          description:
            "Accès complet et sans restriction à toutes les fonctions et tous les paramètres.",
        },
        employee: {
          name: "Employé",
          description:
            "Accès aux clients, à ses propres demandes et aux fichiers associés.",
        },
        office: {
          name: "Bureau",
          description:
            "Gère les clients, demandes, offres, factures et processus administratifs.",
        },
      },
      permissionGroups: {
        customers: "Clients",
        requests: "Demandes",
        offers: "Offres",
        invoices: "Factures",
        payments: "Paiements",
        files: "Fichiers",
        documents: "Documents",
        users: "Utilisateurs",
        employees: "Employés",
        projects: "Projets",
        teams: "Équipes",
        expenses: "Dépenses",
        automations: "Automatisations",
        time: "Suivi du temps",
        employee_documents: "Documents des employés",
        payroll: "Paie",
        roles: "Rôles",
        settings: "Paramètres",
        finance: "Données financières",
        ai: "IA",
        reports: "Rapports",
      },
      permissionActions: {
        view: "Consulter",
        create: "Créer",
        edit: "Modifier",
        delete: "Supprimer",
        view_own: "Consulter les siens",
        view_all: "Tout consulter",
        edit_own: "Modifier les siens",
        edit_all: "Tout modifier",
        assign: "Assigner",
        change_status: "Modifier le statut",
        send: "Envoyer",
        record: "Enregistrer",
        upload: "Téléverser",
        download: "Télécharger",
        deactivate: "Désactiver",
        manage: "Gérer",
        manage_members: "Gérer les membres",
        review_changes: "Examiner les modifications",
        send_password_reset: "Envoyer une réinitialisation du mot de passe",
        change_email: "Modifier l’e-mail",
        submit: "Soumettre",
        approve: "Approuver",
        pay: "Payer",
        view_member_schedule: "Voir les plannings des membres",
        view_member_time: "Voir le temps des membres",
        view_member_salary: "Voir le salaire des membres",
        view_other_managers: "Voir les autres responsables",
        company_edit: "Modifier les paramètres de l’entreprise",
        billing_edit: "Modifier les paramètres de facturation",
        documents_edit: "Modifier les paramètres des documents",
        system_edit: "Modifier les paramètres système",
        use: "Utiliser",
        export: "Exporter",
      },
    },
    expenses: {
      title: "Dépenses",
      subtitle: "Saisir, soumettre et contrôler les notes de frais.",
      newClaim: "Nouvelle note de frais",
      claim: "Note de frais",
      employee: "Employé",
      status: "Statut",
      total: "Total",
      currency: "Devise",
      notes: "Notes",
      items: "Postes de dépense",
      addItem: "Ajouter un poste",
      removeItem: "Supprimer le poste",
      date: "Date",
      type: "Type",
      description: "Description",
      amount: "Montant",
      kilometers: "Kilomètres",
      project: "Projet",
      noProject: "Aucun projet",
      receipt: "Justificatif",
      uploadReceipt: "Télécharger un justificatif",
      noReceipts: "Aucun justificatif téléchargé.",
      saveDraft: "Enregistrer le brouillon",
      submit: "Soumettre",
      pay: "Marquer comme payé",
      empty: "Aucune note de frais trouvée.",
      created: "Note de frais créée.",
      saved: "Note de frais enregistrée.",
      submitted: "Note de frais soumise.",
      paid: "Note de frais marquée comme payée.",
      aiFallback:
        "Les suggestions IA sont indisponibles. Vous pouvez continuer manuellement.",
      statusLabels: {
        draft: "Brouillon",
        submitted: "Soumise",
        paid: "Payée",
      },
      typeLabels: {
        mileage: "Kilométrage",
        meal: "Repas",
        lodging: "Hébergement",
        supplies: "Fournitures",
        other: "Autre",
      },
    },
    settings: {
      title: "Paramètres",
      subtitle: "Configurer l’entreprise, la facturation et l’application.",
      company: "Entreprise",
      billing: "Facturation",
      documents: "Documents",
      localization: "Langue et région",
      aiTab: "IA",
      categories: "Catégories",
      addCategory: "Ajouter une catégorie",
      addSubcategory: "Ajouter une sous-catégorie",
      categoryName: "Nom de la catégorie",
      noParent: "Aucun parent",
      system: "Système",
      ai: {
        title: "Utilisation et budget IA",
        month: "Mois de facturation",
        notConfigured:
          "L’IA est indisponible. Configurez OPENROUTER_API_KEY sur le serveur.",
        model: "Modèle",
        budget: "Budget mensuel",
        used: "Utilisé",
        remaining: "Restant",
        byUser: "Utilisation par utilisateur",
        user: "Utilisateur",
        requests: "Demandes",
        tokens: "Jetons",
        cost: "Coût",
        empty: "Aucune demande IA n’a été effectuée ce mois-ci.",
      },
      emailTemplates: {
        title: "E-mails d’offres et de factures",
        hint: "Personnalisez l’e-mail envoyé avec chaque PDF. Variables disponibles : {{companyName}}, {{customerName}}, {{number}}, {{title}}, {{total}}, {{dueDate}} et {{shareUrl}}.",
        language: "Langue du modèle",
        offer: "E-mail d’offre",
        invoice: "E-mail de facture",
        subject: "Objet",
        body: "Message",
      },
      logo: "Logo",
      legalName: "Raison sociale",
      tradingName: "Nom commercial",
      vatNumber: "Numéro TVA",
      vacationWeeks: "Semaines de vacances",
      useCompanyBranding: "Utiliser l’identité visuelle de l’entreprise",
      useCompanyBrandingHint:
        "Afficher le nom et le logo de l’entreprise dans toute l’application.",
      offerIntro: "Introduction d’offre par défaut",
      footer: "Pied de page",
      currency: "Devise",
      paymentDays: "Délai de paiement (jours)",
      bank: "Nom de la banque",
      referenceType: "Type de référence QR",
      rounding: "Pas d’arrondi",
      vatRegistered: "Assujetti à la TVA",
      taxRates: "Taux de TVA",
      rate: "Taux %",
      validity: "Validité des offres (jours)",
      offerTerms: "Conditions d’offre par défaut",
      invoiceTerms: "Conditions de facture par défaut",
      taxIncluded: "Prix TTC par défaut",
      timezone: "Fuseau horaire",
      parent: "Catégorie parente",
      version: "Version",
      environment: "Environnement",
      storage: "Stockage",
      units: "Unités",
      numbering: "Numérotation",
      activeOnly: "Actifs uniquement",
      addUnit: "Ajouter une unité",
      unitCode: "Code de l’unité",
      unitCodeHint:
        "Code court et stable utilisé dans les documents, par exemple min ou sac.",
      unitName: "Nom de l’unité",
      customTranslations: "Traductions personnalisées",
      taxRateNames: {
        standard: "Taux normal",
        reduced: "Taux réduit",
        zero: "Taux zéro",
      },
      unitNames: {
        h: "Heure",
        pcs: "Pièce",
        m2: "Mètre carré",
        m: "Mètre",
        m3: "Mètre cube",
        kg: "Kilogramme",
        day: "Jour",
        flat: "Forfait",
      },
      sequence: {
        customer: "Clients",
        request: "Demandes",
        offer: "Offres",
        project: "Projets",
        invoice: "Factures",
      },
    },
    teams: {
      title: "Équipes",
      listTitle: "Équipes",
      editorTitle: "Éditeur d’équipe",
      subtitle: "Organiser les employés en équipes.",
      new: "Nouvelle équipe",
      edit: "Modifier l’équipe",
      empty: "Aucune équipe trouvée.",
      name: "Nom",
      nameRequired: "Le nom de l’équipe est requis.",
      description: "Description",
      color: "Couleur",
      active: "Active",
      unnamed: "Équipe sans nom",
      members: "Membres",
      memberCount: "{{count}} membres",
      membersReadOnly: "Les membres sont gérés par les administrateurs.",
      managers: "Responsables",
      managersReadOnly: "Les responsables sont gérés par les administrateurs.",
      selectMembers: "Sélectionner les membres",
      selectManagers: "Sélectionner les responsables",
      selectHint: "Choisir les employés et responsables.",
      managerPermissions: "Droits des responsables",
      managerPermissionsHint:
        "Les responsables voient le périmètre de leur équipe.",
      organization: "Organisation",
      organizationHint:
        "Structurer les départements et équipes, affecter les membres et attribuer des droits par niveau.",
      chartView: "Organigramme",
      treeView: "Vue arborescente",
      addRoot: "Ajouter une organisation",
      addChild: "Ajouter une sous-unité",
      kind: "Type",
      parent: "Unité parente",
      noParent: "Aucune unité parente",
      role: "Rôle",
      permissionGrants: "Droits par périmètre",
      permissionGrantsHint:
        "Accorder l’accès à cette unité ou à cette unité et toutes ses sous-unités.",
      expand: "Développer",
      collapse: "Réduire",
      kinds: {
        company: "Entreprise",
        department: "Département",
        team: "Équipe",
      },
      roles: {
        member: "Membre",
        manager: "Responsable",
      },
      scopes: {
        same_unit: "Cette unité",
        unit_and_descendants: "Cette unité et ses sous-unités",
      },
    },
    automations: {
      webhooks: "Webhooks d’audit",
      description:
        "Envoyez des événements d’audit signés à n8n ou à un autre point de terminaison HTTPS.",
      add: "Ajouter un webhook",
      edit: "Modifier le webhook",
      empty: "Aucun point de terminaison webhook configuré.",
      allEvents: "Tous les événements d’audit (*)",
      deliveries: "livraisons",
      disable: "Désactiver",
      enable: "Activer",
      test: "Envoyer un test",
      rotate: "Renouveler le secret",
      lastDelivery: "Dernière livraison",
      failures: "Échecs",
      events: "Événements",
      event: "Événement",
      attempts: "Tentatives",
      response: "Réponse",
      url: "URL du point de terminaison",
      secret: "Secret de signature (facultatif)",
      secretHint: "Laissez vide pour générer un secret robuste.",
      selectEvents: "Sélectionner les événements d’audit",
      saveSecret: "Enregistrer le secret de signature",
      secretOnce:
        "Ce secret n’est affiché qu’une fois. Enregistrez-le dans n8n avant de fermer.",
      retry: "Réessayer",
      done: "Terminé",
      created: "Créé",
      status: {
        pending: "En attente",
        processing: "Livraison en cours",
        delivered: "Livré",
        failed: "Échoué",
      },
    },
    notifications: {
      subtitle: "Mises à jour sur les demandes, offres et factures.",
      readAll: "Tout marquer comme lu",
      unread: "Non lu",
    },
  },
  es: {
    common: {
      search: "Buscar",
      all: "Todos",
      currency: "Moneda",
      date: "Fecha",
      download: "Descargar",
      file: "Archivo",
      from: "Desde",
      month: "Mes",
      notes: "Notas",
      saved: "Guardado",
      select: "Seleccionar…",
      title: "Título",
      to: "Hasta",
      today: "Hoy",
      year: "Año",
      name: "Nombre",
      phone: "Teléfono",
      address: "Dirección",
      address2: "Dirección adicional",
      postalCode: "Código postal",
      city: "Ciudad",
      language: "Idioma",
      active: "Activo",
      inactive: "Inactivo",
      activate: "Activar",
      deactivate: "Desactivar",
      configured: "Configurado",
      notConfigured: "No configurado",
      default: "Predeterminado",
      status: "Estado",
      exportCsv: "Exportar CSV",
      selectTime: "Seleccionar hora…",
      moveUp: "Subir",
      moveDown: "Bajar",
      rename: "Cambiar nombre",
    },
    dashboard: {
      search: "Buscar en todos los registros…",
      noResults: "No se encontraron resultados.",
      openRequests: "Solicitudes abiertas",
      actionableOffers: "Ofertas pendientes",
      activeProjects: "Proyectos activos",
      overdueInvoices: "Facturas vencidas",
      outstanding: "Importe pendiente",
      today: "Trabajos de hoy",
      noWorkToday: "No hay trabajos programados para hoy.",
      upcoming: "Próximos trabajos",
      noUpcoming: "No hay próximos trabajos.",
      activity: "Actividad reciente",
      noActivity: "Aún no hay actividad.",
      actionItems: "Requiere tu atención",
      attentionItem: "Elemento pendiente",
      count: "Cantidad",
      priority: "Prioridad",
      projectStatusTitle: "Estado de los proyectos",
      projectStatusHint: "Proyectos según su estado actual.",
      financialOverview: "Resumen financiero",
      financialOverviewHint: "Importes facturados, pagados y pendientes.",
      invoiced: "Facturado",
      paid: "Pagado",
      employeeAvailability: "Disponibilidad de empleados",
      employeeAvailabilityHint: "Disponibilidad programada y ausencias de hoy.",
      available: "Disponible",
      absent: "Ausente",
      notScheduled: "Sin programar",
      expenseOverview: "Resumen de gastos",
      expenseOverviewHint: "Gastos enviados durante los últimos seis meses.",
      catalogSales: "Ventas del catálogo",
      catalogSalesHint: "Artículos de catálogo más facturados en seis meses.",
      projectStatuses: {
        planned: "Planificado",
        active: "Activo",
        on_hold: "En pausa",
        completed: "Completado",
        cancelled: "Cancelado",
      },
      priorities: {
        low: "Baja",
        normal: "Normal",
        high: "Alta",
      },
    },
    actionItems: {
      missing_prior_month_payroll_statements:
        "Nóminas pendientes del mes anterior",
      missing_prior_year_salary_certificates:
        "Certificados salariales pendientes del año anterior",
      incomplete_employee_payroll_readiness:
        "Empleados con datos salariales incompletos",
      overdue_invoices: "Facturas vencidas con saldo pendiente",
      low_stock_catalog_items: "Artículos en o por debajo del punto de pedido",
      unscheduled_active_projects: "Proyectos activos sin asignaciones",
      scheduled_offboarding: "Bajas de empleados programadas",
      incomplete_employee_documents: "Empleados sin documentos",
      submitted_requests: "Solicitudes enviadas pendientes de procesar",
      offers_requiring_action: "Ofertas que requieren atención",
    },
    planner: {
      title: "Planificador del equipo",
      previous: "Periodo anterior",
      previousShort: "Anterior",
      today: "Hoy",
      next: "Periodo siguiente",
      nextShort: "Siguiente",
      anchorDate: "Fecha de planificación",
      view: "Vista del planificador",
      day: "Día",
      week: "Semana",
      month: "Mes",
      teamMember: "Miembro del equipo",
      holidays: "Días festivos",
      holidaysUnavailable: "No se pudieron cargar los días festivos.",
      unassigned: "Sin asignar",
      noTeam: "No hay miembros activos del equipo.",
      newAssignment: "Nueva asignación",
      editAssignment: "Editar asignación",
      assign: "Asignar",
      backlog: "Proyectos sin programar",
      backlogHelp:
        "Arrastra un proyecto a una persona y fecha, o selecciónalo.",
      noBacklog: "No hay proyectos sin programar.",
      selectProject: "Seleccionar proyecto",
      selectMember: "Seleccionar miembro",
      startTime: "Inicio",
      endTime: "Fin",
      conflicts: "Conflictos de programación",
      openConflict: "Abrir proyecto",
      force: "Programar de todos modos",
    },
    customers: {
      title: "Clientes",
      subtitle: "Gestionar clientes, direcciones y actividad.",
      new: "Nuevo cliente",
      edit: "Editar cliente",
      empty: "No se encontraron clientes.",
      search: "Buscar clientes…",
      allStatuses: "Todos los estados",
      contact: "Contacto",
      address: "Dirección",
      activity: "Actividad",
      duplicateWarning: "Se encontraron posibles duplicados.",
      private: "Particular",
      company: "Empresa",
      number: "Número",
      archived: "Archivado",
      created: "Creado",
      type: "Tipo de cliente",
      companyName: "Nombre de la empresa",
      language: "Idioma de los documentos",
      notes: "Notas internas",
      identity: "Identidad y contacto",
      contactHint:
        "Se requiere un número de teléfono o una dirección de correo.",
      contactRequired:
        "Introduce un número de teléfono o una dirección de correo.",
      addresses: "Direcciones",
      billingAddress: "Dirección de facturación",
      workAddress: "Dirección del trabajo",
      sameAddress: "Usar la dirección de facturación para el trabajo",
      addressLine1: "Dirección",
      addressLine2: "Dirección adicional",
      postalCode: "Código postal",
      city: "Ciudad",
      country: "País",
      location: {
        fill: "Usar ubicación actual",
        overwrite:
          "¿Sustituir los campos de dirección por la ubicación actual?",
        success: "Dirección rellenada desde la ubicación actual.",
        errors: {
          unsupported: "Este navegador no admite la ubicación.",
          insecure:
            "La ubicación requiere HTTPS (o localhost durante el desarrollo).",
          denied:
            "Se denegó el permiso de ubicación. Permítalo en los ajustes del navegador.",
          unavailable: "No se pudo determinar la ubicación actual.",
          timeout:
            "La búsqueda de ubicación agotó el tiempo. Inténtelo de nuevo.",
          no_address: "No se encontró ninguna dirección suiza cercana.",
          network: "No se pudo acceder al servicio suizo de direcciones.",
        },
      },
      details: "Detalles del cliente",
      summary: "Resumen",
      noProjects: "No hay proyectos.",
      projects: "Proyectos",
    },
    requests: {
      title: "Solicitudes",
      subtitle: "Registrar y revisar solicitudes de clientes.",
      new: "Nueva solicitud",
      empty: "No se encontraron solicitudes.",
      details: "Detalles de la solicitud",
      description: "Descripción",
      customerStep: "Cliente",
      workStep: "Trabajo solicitado",
      scheduleStep: "Programación",
      reviewStep: "Revisión",
      shortDescription: "Descripción breve",
      selectCustomer: "Seleccionar cliente",
      category: "Categoría",
      subcategory: "Subcategoría",
      pricing: "Expectativa de precio",
      priority: "Prioridad",
      requestedDate: "Fecha solicitada",
      submitOffice: "Enviar a oficina",
      createOffer: "Crear oferta",
      assigned: "Empleados asignados",
      unassigned: "Sin asignar",
      search: "Buscar solicitudes…",
      allStatuses: "Todos los estados",
      number: "Número",
      created: "Creado",
      captureHint:
        "Registre la solicitud ahora; la oficina podrá calcular el precio más adelante.",
      customerAndWork: "Cliente y trabajo solicitado",
      createCustomer: "Crear un cliente nuevo",
      general: "General",
      siteAddress: "Dirección del trabajo",
      expectations: "Expectativas",
      timeMaterial: "Tiempo y materiales",
      fixedPrice: "Precio fijo",
      fixedAmount: "Importe fijo",
      offerRequired: "Oferta requerida",
      appointmentRequired: "Cita requerida",
      asap: "Lo antes posible",
      desiredDate: "Fecha deseada",
      date: "Fecha",
      startTime: "Hora de inicio (formato de 24 h HH:mm)",
      endTime: "Hora de fin (formato de 24 h HH:mm)",
      scheduling: "Programación",
      photos: "Fotos",
      addPhotos: "Añadir fotos",
      photoHint: "Añada fotos claras del lugar y del trabajo solicitado.",
      takePhoto: "Hacer una foto",
      uploadFiles: "Subir archivos",
      cameraHint:
        "Usa la cámara del dispositivo o selecciona imágenes existentes.",
      noPhotos: "No se han añadido fotos.",
      saveDraft: "Guardar borrador",
      ai: {
        title: "Captura asistida por IA",
        hint: "Describa o dicte la solicitud en un espacio separado y revise después los valores propuestos para el formulario.",
        dictation: "Dictado",
        stopDictation: "Detener grabación",
        cancelDictation: "Cancelar grabación",
        autocomplete: "Rellenar automáticamente",
        checkingAvailability: "Comprobando disponibilidad de IA…",
        availabilityError:
          "No se pudo comprobar la disponibilidad de IA. Puede continuar manualmente.",
        disabled:
          "La asistencia de IA no está configurada. Puede continuar manualmente.",
        noPermission: "No tiene permiso para utilizar la asistencia de IA.",
        unavailable:
          "La asistencia de IA no está disponible para esta cuenta. Puede continuar manualmente.",
        budgetExhausted:
          "Se ha agotado el presupuesto mensual de IA. Puede continuar manualmente.",
        budgetRemaining: "Presupuesto de IA restante: ${{amount}}.",
        recordingTime: "Tiempo de grabación {{time}}",
        recordingUnsupported: "Este navegador no admite la grabación de audio.",
        recordingUnsupportedManual:
          "Este navegador no admite el dictado; la función de autocompletar y la entrada manual siguen disponibles.",
        requestingMicrophone: "Esperando permiso para usar el micrófono…",
        recording: "Grabación en curso.",
        processing: "Subiendo y transcribiendo la grabación…",
        transcribing: "Transcribiendo…",
        addNotesFirst:
          "Introduzca primero al menos tres caracteres en una descripción.",
        emptyRecording: "No se ha capturado audio.",
        recordingCancelled: "Grabación cancelada.",
        microphoneError: "No se pudo iniciar el micrófono: {{message}}",
        dictationError: "No se pudo procesar la grabación: {{message}}",
        autocompleteError: "No se pudo generar la solicitud: {{message}}",
        noChanges: "La IA no sugirió ningún cambio.",
        transcriptLabel: "Transcripción",
        dictationApplied:
          "El dictado se resumió en la solicitud. Revise los campos antes de guardar.",
        autocompleteApplied:
          "Las sugerencias se añadieron a la solicitud. Revise los campos antes de guardar.",
        reviewTitle: "Revisar cambios propuestos",
        reviewHint:
          "Algunas sugerencias sustituyen información ya introducida. Compare los valores antes de aplicarlos.",
        keepCurrent: "Conservar valores actuales",
        applyChanges: "Aplicar cambios propuestos",
        currentValue: "Actual",
        proposedValue: "Propuesto",
        emptyValue: "Vacío",
        unknownSelection: "Selección no disponible",
        autocompleteTitle: "Describir la solicitud del cliente",
        generate: "Generar solicitud",
        promptLabel: "Detalles de la solicitud",
        promptHint:
          "Incluya el trabajo solicitado, el alcance, la programación, la prioridad y las expectativas de precio acordadas.",
        dictationTitle: "Dictar la solicitud del cliente",
        dictationHint:
          "Describa todo el trabajo relevante, el alcance, la programación, la prioridad y los datos de precio. Se generará un resumen profesional a partir de la grabación.",
        startDictation: "Iniciar grabación",
        processingRecording:
          "Transcribiendo y preparando un resumen profesional…",
        fields: {
          shortDescription: "Descripción breve",
          description: "Descripción detallada",
          category: "Categoría",
          subcategory: "Subcategoría",
          pricing: "Expectativa de precio",
          fixedAmount: "Importe fijo",
          scheduling: "Programación",
          requestedDate: "Fecha deseada",
          startTime: "Hora de inicio preferida",
          endTime: "Hora de finalización preferida",
          priority: "Prioridad",
        },
      },
    },
    offers: {
      title: "Ofertas",
      subtitle: "Preparar, enviar y seguir ofertas comerciales.",
      new: "Nueva oferta",
      edit: "Editar oferta",
      offer: "Oferta",
      empty: "No se encontraron ofertas.",
      allStatuses: "Todos los estados",
      number: "Número",
      validUntil: "Válida hasta",
      preview: "Vista previa PDF",
      ready: "Marcar lista",
      send: "Enviar por correo",
      accept: "Aceptar oferta",
      decline: "Marcar rechazada",
      hold: "Poner en espera",
      resume: "Reanudar",
      viewProject: "Ver proyecto",
      status: "Estado de la oferta",
      details: "Detalles de la oferta",
      introduction: "Introducción",
      texts: "Condiciones y notas",
      terms: "Condiciones",
      internalNotes: "Notas internas",
      documentTexts: "Textos del documento",
      markReady: "Marcar como lista",
      revision: "Revisión",
    },
    projects: {
      title: "Proyectos",
      subtitle:
        "Planificar trabajo, personas, documentos, inventario y costes.",
      project: "Proyecto",
      new: "Nuevo proyecto",
      edit: "Editar proyecto",
      empty: "No se encontraron proyectos.",
      search: "Buscar proyectos…",
      allStatuses: "Todos los estados",
      schedule: "Programación",
      managers: "Responsables",
      parent: "Proyecto principal",
      noParent: "Sin proyecto principal",
      selectCustomer: "Seleccionar cliente",
      plannedStart: "Inicio previsto",
      plannedEnd: "Fin prevista",
      internalNotes: "Notas internas",
      overview: "Resumen",
      documents: "Documentos",
      team: "Equipo",
      financials: "Finanzas",
      details: "Detalles del proyecto",
      summary: "Resumen",
      children: "Subproyectos",
      noDescription: "Sin descripción.",
      noDocuments: "No hay documentos vinculados.",
      noMembers: "No hay miembros del proyecto.",
      budget: "Presupuesto",
      revenueBudget: "Ingresos",
      laborBudget: "Mano de obra",
      materialBudget: "Material",
      manualCost: "Costes registrados",
      costs: "Costes",
      noCosts: "No hay costes registrados.",
      inventory: "Inventario",
      reservations: "Reservas",
      issued: "Entregado",
      remaining: "Restante",
      shortage: "faltante",
      issue: "Entregar existencias",
      release: "Liberar reserva",
      return: "Devolver existencias",
      returnStock: "Devolver",
      noReservations: "No hay reservas de inventario.",
      transition: {
        active: "Iniciar proyecto",
        on_hold: "Poner en espera",
        completed: "Completar proyecto",
        cancelled: "Cancelar proyecto",
      },
    },
    invoices: {
      title: "Facturas",
      subtitle: "Emitir facturas suizas y seguir pagos.",
      new: "Nueva factura",
      edit: "Editar factura",
      invoice: "Factura",
      empty: "No se encontraron facturas.",
      allStatuses: "Todos los estados",
      number: "Número",
      date: "Fecha de factura",
      dueDate: "Vencimiento",
      payment: "Pago",
      details: "Detalles de la factura",
      referenceType: "Tipo de referencia",
      paymentTerms: "Condiciones de pago",
      status: "Estado de la factura",
      issue: "Emitir factura",
      send: "Enviar por correo",
      cancel: "Cancelar factura",
      cancelReason: "Motivo de cancelación",
      billing: "Dirección de facturación",
      sharing: {
        title: "Enlaces seguros de factura",
        hint: "Cree un enlace de descarga privado que caduca a los tres meses. El enlace solo se muestra una vez.",
        create: "Crear enlace compartido",
        newLink: "Nuevo enlace compartido",
        copied: "Copiado",
        copy: "Copiar enlace",
        inactive: "Enlace inactivo",
        active: "Enlace activo",
        expires: "Caduca el {{date}} · {{count}} descargas",
        revoke: "Revocar",
      },
    },
    payments: {
      title: "Pagos",
      amount: "Importe",
      date: "Fecha de pago",
      method: "Método",
      bank: "Transferencia bancaria",
      cash: "Efectivo",
      card: "Tarjeta",
      other: "Otro",
      reference: "Referencia",
      record: "Registrar pago",
      paid: "Pagado",
      deleteConfirm: "¿Eliminar este pago?",
    },
    commercial: {
      positions: "Partidas",
      addPosition: "Añadir partida",
      type: "Tipo",
      title: "Título",
      description: "Descripción",
      quantity: "Cantidad",
      unit: "Unidad",
      unitPrice: "Precio unitario",
      discountPercent: "Descuento %",
      taxRate: "IVA %",
      estimatedSubtotal: "Subtotal estimado",
      subtotal: "Subtotal",
      tax: "IVA",
      total: "Total",
      terms: "Condiciones",
      notes: "Notas internas",
      customerNotes: "Notas visibles para el cliente",
      previewCurrent: "Previsualizar PDF actual",
      issuedPdf: "PDF emitido",
      validUntil: "Válida hasta",
      schedule: "Programación",
      start: "Inicio",
      end: "Fin",
      priority: "Prioridad",
      position: "Partida",
      work: "Trabajo",
      product: "Producto",
      material: "Material",
      flatRate: "Tarifa plana",
      text: "Texto",
      discount: "Descuento %",
      catalogItem: "Artículo del catálogo",
      selectCatalogItem: "Seleccionar un artículo…",
      addFromCatalog: "Añadir desde el catálogo",
      trackedLineLocked:
        "El tipo y la unidad están bloqueados mientras este artículo controlado esté vinculado.",
      makeManual: "Convertir en manual",
      insufficientAvailability:
        "La cantidad solicitada supera las existencias disponibles.",
    },
    catalog: {
      title: "Inventario",
      subtitle: "Gestionar artículos, paquetes, existencias y ubicaciones.",
      add: "Añadir artículo",
      edit: "Editar artículo",
      empty: "No hay artículos.",
      inactive: "Mostrar inactivos",
      name: "Nombre",
      sku: "Referencia",
      type: "Tipo",
      unit: "Unidad",
      price: "Precio unitario",
      tax: "IVA %",
      items: "Artículos",
      barcode: "Código de barras",
      stockTracked: "Controlar inventario",
      defaultUnitCost: "Coste unitario predeterminado",
      reorderPoint: "Punto de reposición",
    },
    inventory: {
      stock: "Existencias",
      movements: "Movimientos",
      locations: "Ubicaciones",
      location: "Ubicación",
      allLocations: "Todas las ubicaciones",
      allMovements: "Todos los movimientos",
      receive: "Recibir existencias",
      receipt: "Recibir existencias",
      adjust: "Ajustar",
      adjustment: "Ajustar existencias",
      transfer: "Transferir",
      fromLocation: "Ubicación de origen",
      toLocation: "Ubicación de destino",
      direction: "Dirección",
      in: "Aumentar",
      out: "Disminuir",
      quantity: "Cantidad",
      unitCost: "Coste unitario",
      reason: "Motivo",
      onHand: "En existencia",
      reserved: "Reservado",
      available: "Disponible",
      reorder: "Reposición",
      lowStock: "Existencias bajas",
      noStock: "No hay saldos de inventario.",
      noMovements: "No hay movimientos de inventario.",
      noLocations: "No hay ubicaciones.",
      addLocation: "Añadir ubicación",
      editLocation: "Editar ubicación",
      code: "Código",
      default: "Predeterminada",
    },
    users: {
      title: "Usuarios",
      subtitle: "Invitar empleados y asignar roles de acceso.",
      invite: "Invitar usuario",
      newInvitation: "Nueva invitación",
      roles: "Roles",
      sendInvite: "Enviar invitación",
      name: "Nombre",
      actions: "Acciones",
      resend: "Reenviar",
      deactivate: "Desactivar",
      deactivateConfirm: "¿Desactivar este usuario?",
      empty: "No hay usuarios.",
    },
    roles: {
      title: "Roles y permisos",
      add: "Añadir rol",
      name: "Nombre del rol",
      description: "Descripción",
      deleteConfirm: "¿Eliminar este rol?",
      permissionCount: "{{count}} permisos",
      userCount: "{{count}} usuarios",
      permissionCount_one: "{{count}} permiso",
      permissionCount_other: "{{count}} permisos",
      userCount_one: "{{count}} usuario",
      userCount_other: "{{count}} usuarios",
      system: {
        administrator: {
          name: "Administrador",
          description:
            "Acceso completo y sin restricciones a todas las funciones y ajustes.",
        },
        employee: {
          name: "Empleado",
          description:
            "Acceso a clientes, solicitudes propias y archivos relacionados.",
        },
        office: {
          name: "Oficina",
          description:
            "Gestiona clientes, solicitudes, ofertas, facturas y procesos administrativos.",
        },
      },
      permissionGroups: {
        customers: "Clientes",
        requests: "Solicitudes",
        offers: "Ofertas",
        invoices: "Facturas",
        payments: "Pagos",
        files: "Archivos",
        documents: "Documentos",
        users: "Usuarios",
        employees: "Empleados",
        projects: "Proyectos",
        teams: "Equipos",
        expenses: "Gastos",
        automations: "Automatizaciones",
        time: "Control horario",
        employee_documents: "Documentos de empleados",
        payroll: "Nómina",
        roles: "Roles",
        settings: "Ajustes",
        finance: "Datos financieros",
        ai: "IA",
        reports: "Informes",
      },
      permissionActions: {
        view: "Ver",
        create: "Crear",
        edit: "Editar",
        delete: "Eliminar",
        view_own: "Ver los propios",
        view_all: "Ver todos",
        edit_own: "Editar los propios",
        edit_all: "Editar todos",
        assign: "Asignar",
        change_status: "Cambiar estado",
        send: "Enviar",
        record: "Registrar",
        upload: "Subir",
        download: "Descargar",
        deactivate: "Desactivar",
        manage: "Gestionar",
        manage_members: "Gestionar miembros",
        review_changes: "Revisar cambios",
        send_password_reset: "Enviar restablecimiento de contraseña",
        change_email: "Cambiar correo electrónico",
        submit: "Enviar",
        approve: "Aprobar",
        pay: "Pagar",
        view_member_schedule: "Ver horarios de miembros",
        view_member_time: "Ver tiempo de miembros",
        view_member_salary: "Ver salarios de miembros",
        view_other_managers: "Ver otros responsables",
        company_edit: "Editar los ajustes de empresa",
        billing_edit: "Editar los ajustes de facturación",
        documents_edit: "Editar los ajustes de documentos",
        system_edit: "Editar los ajustes del sistema",
        use: "Usar",
        export: "Exportar",
      },
    },
    expenses: {
      title: "Gastos",
      subtitle: "Registrar, enviar y revisar gastos de empleados.",
      newClaim: "Nueva liquidación de gastos",
      claim: "Liquidación de gastos",
      employee: "Empleado",
      status: "Estado",
      total: "Total",
      currency: "Moneda",
      notes: "Notas",
      items: "Partidas de gasto",
      addItem: "Añadir partida",
      removeItem: "Eliminar partida",
      date: "Fecha",
      type: "Tipo",
      description: "Descripción",
      amount: "Importe",
      kilometers: "Kilómetros",
      project: "Proyecto",
      noProject: "Sin proyecto",
      receipt: "Justificante",
      uploadReceipt: "Subir justificante",
      noReceipts: "No hay justificantes subidos.",
      saveDraft: "Guardar borrador",
      submit: "Enviar",
      pay: "Marcar como pagado",
      empty: "No se encontraron liquidaciones de gastos.",
      created: "Liquidación de gastos creada.",
      saved: "Liquidación de gastos guardada.",
      submitted: "Liquidación de gastos enviada.",
      paid: "Liquidación de gastos marcada como pagada.",
      aiFallback:
        "Las sugerencias de IA no están disponibles. Puedes continuar manualmente.",
      statusLabels: {
        draft: "Borrador",
        submitted: "Enviada",
        paid: "Pagada",
      },
      typeLabels: {
        mileage: "Kilometraje",
        meal: "Comida",
        lodging: "Alojamiento",
        supplies: "Suministros",
        other: "Otro",
      },
    },
    settings: {
      title: "Ajustes",
      subtitle: "Configurar empresa, facturación y aplicación.",
      company: "Empresa",
      billing: "Facturación",
      addCategory: "Añadir categoría",
      addSubcategory: "Añadir subcategoría",
      categoryName: "Nombre de categoría",
      noParent: "Sin categoría superior",
      documents: "Documentos",
      localization: "Idioma y región",
      aiTab: "IA",
      categories: "Categorías",
      system: "Sistema",
      ai: {
        title: "Uso y presupuesto de IA",
        month: "Mes de facturación",
        notConfigured:
          "La IA no está disponible. Configure OPENROUTER_API_KEY en el servidor.",
        model: "Modelo",
        budget: "Presupuesto mensual",
        used: "Utilizado",
        remaining: "Restante",
        byUser: "Uso por usuario",
        user: "Usuario",
        requests: "Solicitudes",
        tokens: "Tokens",
        cost: "Coste",
        empty: "No se realizaron solicitudes de IA este mes.",
      },
      emailTemplates: {
        title: "Correos de ofertas y facturas",
        hint: "Personalice el correo enviado con cada PDF. Marcadores disponibles: {{companyName}}, {{customerName}}, {{number}}, {{title}}, {{total}}, {{dueDate}} y {{shareUrl}}.",
        language: "Idioma de la plantilla",
        offer: "Correo de oferta",
        invoice: "Correo de factura",
        subject: "Asunto",
        body: "Mensaje",
      },
      logo: "Logotipo",
      legalName: "Razón social",
      tradingName: "Nombre comercial",
      vatNumber: "Número de IVA",
      vacationWeeks: "Semanas de vacaciones",
      useCompanyBranding: "Usar la identidad visual de la empresa",
      useCompanyBrandingHint:
        "Mostrar el nombre y el logotipo de la empresa en toda la aplicación.",
      offerIntro: "Introducción de oferta predeterminada",
      footer: "Pie de documento",
      currency: "Moneda",
      paymentDays: "Plazo de pago (días)",
      bank: "Nombre del banco",
      referenceType: "Tipo de referencia QR",
      rounding: "Paso de redondeo",
      vatRegistered: "Registrado para IVA",
      taxRates: "Tipos impositivos",
      rate: "Tipo %",
      validity: "Validez de ofertas (días)",
      offerTerms: "Condiciones de oferta predeterminadas",
      invoiceTerms: "Condiciones de factura predeterminadas",
      taxIncluded: "Precios con impuestos por defecto",
      timezone: "Zona horaria",
      parent: "Categoría superior",
      version: "Versión",
      environment: "Entorno",
      storage: "Almacenamiento",
      units: "Unidades",
      numbering: "Numeración",
      activeOnly: "Solo activas",
      addUnit: "Añadir unidad",
      unitCode: "Código de unidad",
      unitCodeHint:
        "Código breve y estable utilizado en documentos, por ejemplo min o saco.",
      unitName: "Nombre de la unidad",
      customTranslations: "Traducciones personalizadas",
      taxRateNames: {
        standard: "Tipo general",
        reduced: "Tipo reducido",
        zero: "Tipo cero",
      },
      unitNames: {
        h: "Hora",
        pcs: "Pieza",
        m2: "Metro cuadrado",
        m: "Metro",
        m3: "Metro cúbico",
        kg: "Kilogramo",
        day: "Día",
        flat: "Tarifa plana",
      },
      sequence: {
        customer: "Clientes",
        request: "Solicitudes",
        offer: "Ofertas",
        project: "Proyectos",
        invoice: "Facturas",
      },
    },
    teams: {
      title: "Equipos",
      listTitle: "Equipos",
      editorTitle: "Editor de equipos",
      subtitle: "Organizar empleados en equipos.",
      new: "Nuevo equipo",
      edit: "Editar equipo",
      empty: "No se encontraron equipos.",
      name: "Nombre",
      nameRequired: "El nombre del equipo es obligatorio.",
      description: "Descripción",
      color: "Color",
      active: "Activo",
      unnamed: "Equipo sin nombre",
      members: "Miembros",
      memberCount: "{{count}} miembros",
      membersReadOnly: "Los administradores gestionan los miembros.",
      managers: "Responsables",
      managersReadOnly: "Los administradores gestionan los responsables.",
      selectMembers: "Seleccionar miembros",
      selectManagers: "Seleccionar responsables",
      selectHint: "Elegir empleados y responsables.",
      managerPermissions: "Permisos de responsables",
      managerPermissionsHint: "Los responsables ven el ámbito de su equipo.",
      organization: "Organización",
      organizationHint:
        "Estructura departamentos y equipos, asigna miembros y concede permisos por nivel.",
      chartView: "Organigrama",
      treeView: "Vista de árbol",
      addRoot: "Añadir organización",
      addChild: "Añadir subunidad",
      kind: "Tipo",
      parent: "Unidad superior",
      noParent: "Sin unidad superior",
      role: "Rol",
      permissionGrants: "Permisos por ámbito",
      permissionGrantsHint:
        "Concede acceso a esta unidad o a esta unidad y todas sus subunidades.",
      expand: "Expandir",
      collapse: "Contraer",
      kinds: {
        company: "Empresa",
        department: "Departamento",
        team: "Equipo",
      },
      roles: {
        member: "Miembro",
        manager: "Responsable",
      },
      scopes: {
        same_unit: "Esta unidad",
        unit_and_descendants: "Esta unidad y sus subunidades",
      },
    },
    automations: {
      webhooks: "Webhooks de auditoría",
      description:
        "Envía eventos de auditoría firmados a n8n u otro punto de conexión HTTPS.",
      add: "Añadir webhook",
      edit: "Editar webhook",
      empty: "No hay puntos de conexión webhook configurados.",
      allEvents: "Todos los eventos de auditoría (*)",
      deliveries: "entregas",
      disable: "Desactivar",
      enable: "Activar",
      test: "Enviar prueba",
      rotate: "Rotar secreto",
      lastDelivery: "Última entrega",
      failures: "Fallos",
      events: "Eventos",
      event: "Evento",
      attempts: "Intentos",
      response: "Respuesta",
      url: "URL del punto de conexión",
      secret: "Secreto de firma (opcional)",
      secretHint: "Déjalo vacío para generar un secreto seguro.",
      selectEvents: "Seleccionar eventos de auditoría",
      saveSecret: "Guardar el secreto de firma",
      secretOnce:
        "Este secreto se muestra una sola vez. Guárdalo en n8n antes de cerrar.",
      retry: "Reintentar",
      done: "Hecho",
      created: "Creado",
      status: {
        pending: "Pendiente",
        processing: "Entregando",
        delivered: "Entregado",
        failed: "Fallido",
      },
    },
    notifications: {
      subtitle: "Actualizaciones sobre solicitudes, ofertas y facturas.",
      readAll: "Marcar todo como leído",
      unread: "No leído",
    },
  },
} as const;
